/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />
/// <reference path="../../components/common/inventory.common.context.ts" />
/// <reference path="../../components/baseclasses/dataMaintenanceContextBase.ts" />
/// <reference path="../../components/filters/invOnHand.ts" />

module Meevo.Plugins.PurchaseOrder {
    import ProductInventoryTypeEnum = Meevo.Model.ProductInventoryTypeEnum;
    import PurchaseOrderStateEnum = Meevo.Model.PurchaseOrderStateEnum;
    import PurchaseOrderDetails = Meevo.Model.PurchaseOrderDetails;
    import MaintenanceFormState = Meevo.Model.MaintenanceFormState;
    import ProductPackageTypeEnum = Meevo.Model.ProductPackageTypeEnum;
    import PoReceivalLineItem = Meevo.Model.PoReceivalLineItem;
    import SupplyCategoryEnum = Meevo.Model.SupplyCategoryEnum;
    import PurchaseOrderLineItemResponseCodeEnum = Meevo.Model.PurchaseOrderLineItemResponseCodeEnum;
    import ProductUsageAmountTypeEnum = Meevo.Model.ProductUsageAmountTypeEnum;
    import ExternalInventoryAppEnum = Meevo.Model.ExternalInventoryAppEnum;

    interface IPurchaseOrderProductSearchCriteria {
        coBusinessTypeId: string;
        coFilterByLocationId: string;
        includeActive: boolean;
        purchaseOrderId?: Guid;
        distributorId?: Guid;
        newDistributorId?: Guid;
        manufacturerId?: Guid;
        productInventoryType: Meevo.Model.ProductInventoryTypeEnum;
        supplyCategoryEnum?: number;
        excludeIdList: string[];
        excludeItemsAlreadyOnOrder: boolean;
        sortBy?: string;
        manufacturerIds: Guid[];
        productCategoryIds: Guid[],
        productSubCategoryIds: Guid[];
        supplyCategoryIds: SupplyCategoryEnum[];
    }

    export class PurchaseOrderContext extends Meevo.Components.Common.InventoryCommonContext {
        inSaveProcess: boolean = false;
        backupPurchaseOrder: Meevo.Model.PurchaseOrder;
        itemsArrayCtrl: any;
        selectAllBox: boolean;
        mode: Meevo.Model.MaintenanceFormState; // This controls the UI behavior for the Desktop
        public backup: any;
        public securityKeys = Meevo.Components.Common.SecurityKeys;
        public securityParts = Meevo.Components.Common.SecurityParts;
        public trackingService: Meevo.Components.Tracking.ITrackingService;
        public addSecurityKey: string;
        public editSecurityKey: string;
        public editRecivalSecurityKey: string;
        public discountSecurityKey: string;
        public addNoteSecurityKey: string;
        public editNoteSecurityKey: string;
        public deleteNoteSecurityKey: string;
        public readNoteSecurityKey: string;
        public submitSecurityKey: string;

        public highlightId: string;
        public filterVariant: any;
        public meevoFormSearch: any;
        public deleteSecurityKey: string;
        public PURCHASEORDER_COUNT_WRITE: string;
        public PURCHASEORDER_COUNT_DELETE: string;
        public PURCHASEORDER_COUNT_READ: string;
        public DATA_PRODUCT_TAB_MAIN: string;
        public products: any;
        public floorLocations: any;
        public distributors: any;
        public manufacturers: any;
        public productVariantFilter: string;
        public includeDiscontinuedProductVariant: boolean;
        public productVariantInventoryType: ProductInventoryTypeEnum;
        public ProductPackageTypeEnum = ProductPackageTypeEnum;
        public productTypes: any;
        public purchaseOrder: Meevo.Model.PurchaseOrder;
        public purchaseOrders: any;
        public lineItems: Meevo.Model.PurchaseOrderDetails;
        public purchaseOrderNote: Meevo.Model.PurchaseOrderNote;
        public purchaseOrderNotes: any;
        public purchaseOrderStates: any;
        public product: any;
        public controller: any;
        public confirmationMessage: string;
        public originalActualCount: number;
        public openPurchaseOrderStateEnum = ProductInventoryTypeEnum.Other;
        public ProductInventoryTypeEnum = ProductInventoryTypeEnum;
        public PurchaseOrderLineItemResponseCodeEnum = PurchaseOrderLineItemResponseCodeEnum;
        public PurchaseOrderStateEnum = PurchaseOrderStateEnum;
        public searchCriteria: any;
        public productSearchCriteria: IPurchaseOrderProductSearchCriteria = {
            coBusinessTypeId: null,
            coFilterByLocationId: null,
            distributorId: null,
            newDistributorId: null,
            purchaseOrderId: null,
            includeActive: true,
            manufacturerId: null,
            productInventoryType: Meevo.Model.ProductInventoryTypeEnum.Retail,
            supplyCategoryEnum: null,
            excludeIdList: [],
            excludeItemsAlreadyOnOrder: false,
            sortBy: "VariantSku",
            manufacturerIds: [],
            productCategoryIds: [],
            productSubCategoryIds: [],
            supplyCategoryIds: [],
        };
        public purchaseOrderProductSearchCriteria: IPurchaseOrderProductSearchCriteria = {
            coBusinessTypeId: null,
            coFilterByLocationId: null,
            distributorId: null,
            newDistributorId: null,
            purchaseOrderId: null,
            includeActive: true,
            manufacturerId: null,
            productInventoryType: Meevo.Model.ProductInventoryTypeEnum.Retail,
            supplyCategoryEnum: null,
            excludeIdList: [],
            excludeItemsAlreadyOnOrder: false,
            sortBy: "VariantSku",
            manufacturerIds: [],
            productCategoryIds: [],
            productSubCategoryIds: [],
            supplyCategoryIds: [],
        };
        public showResults: boolean;
        public isFirstSearch: boolean;
        public lockSort: boolean = false;
        public notePageNumber: number
        public recivalpageNumber: number;
        public virtualMaximum: number;
        public $q: ng.IQService;
        public resolvedPromise = true;
        public viewNotes = false;
        public purchaseOrderId: any;
        public topIndex: number;
        public infiteitems: any;
        public customColumns: any;
        public dateCreatedColumn: any;
        public isQuantityMode: boolean = true;
        public showReceival: boolean;
        public poReceival: Meevo.Model.PurchaseOrderReceival;
        public backupPoReceival: Meevo.Model.PurchaseOrderReceival;
        public emptyPoReceival: Meevo.Model.PurchaseOrderReceival;
        public receivableLineItems: any;
        public $timeout: ng.ITimeoutService;
        public showStats: boolean = false;
        public showFilter: boolean = true;
        public width: number = 1200;
        public smartSearchFilter = "";
        public smartSearchFilter2 = "";
        public smartSearchFilter3 = "";
        public allVariants: any;
        public tempProductList: any;
        public preventUsageTracking: boolean;
        public emailTo: string = "";
        public emailList: Array<string> = [""];
        public emailSubject: string = "";
        public emailBody: string = "";
        public emailFileType: string = "pdf";
        public emailSection: number = 0;
        public showExternalOrderingAction: boolean = false;
        public isAvedaAccountObjectStateActive = false;
        public auditHistory: any;
        public items: Meevo.Model.PurchaseOrderDetails[];
        public supplyCategories = [
            { id: SupplyCategoryEnum.Cleaning, displayName: this.$translate.instant("LABEL_CLEANING_SUPPLIES"), value: null, label: 'LABEL_CLEANING_SUPPLIES' },
            { id: SupplyCategoryEnum.KitchenSupply, displayName: this.$translate.instant("LABEL_KITCHEN_SUPPLIES"), value: SupplyCategoryEnum.Cleaning, label: 'LABEL_KITCHEN_SUPPLIES' },
            { id: SupplyCategoryEnum.OfficeSupply, displayName: this.$translate.instant("LABEL_OFFICE_SUPPLIES"), value: SupplyCategoryEnum.OfficeSupply, label: 'LABEL_OFFICE_SUPPLIES' },
            { id: SupplyCategoryEnum.Refreshment, displayName: this.$translate.instant("LABEL_REFRESHMENTS"), value: SupplyCategoryEnum.KitchenSupply, label: 'LABEL_REFRESHMENTS' },
            { id: SupplyCategoryEnum.Tools, displayName: this.$translate.instant("LABEL_TOOLS_SUPPLIES"), value: SupplyCategoryEnum.KitchenSupply, label: 'LABEL_TOOLS_SUPPLIES' },
            { id: SupplyCategoryEnum.MedspaSupply, displayName: this.$translate.instant("LABEL_MEDSPA_SUPPLIES"), value: SupplyCategoryEnum.Refreshment, label: 'LABEL_MEDSPA_SUPPLIES' },
            { id: SupplyCategoryEnum.NailSupply, displayName: this.$translate.instant("LABEL_NAIL_SUPPLIES"), value: SupplyCategoryEnum.Refreshment, label: 'LABEL_NAIL_SUPPLIES' },
            { id: SupplyCategoryEnum.SpaSupply, displayName: this.$translate.instant("LABEL_SPA_SUPPLIES"), value: SupplyCategoryEnum.Refreshment, label: 'LABEL_SPA_SUPPLIES' },
            { id: SupplyCategoryEnum.SalonSupply, displayName: this.$translate.instant("LABEL_SALON_SUPPLIES"), value: SupplyCategoryEnum.Refreshment, label: 'LABEL_SALON_SUPPLIES' },
            { id: SupplyCategoryEnum.WaxingSupply, displayName: this.$translate.instant("LABEL_WAXING_SUPPLIES"), value: SupplyCategoryEnum.Refreshment, label: 'LABEL_WAXING_SUPPLIES' },
            { id: SupplyCategoryEnum.OtherSupply, displayName: this.$translate.instant("LABEL_OTHER_SUPPLIES"), value: SupplyCategoryEnum.Refreshment, label: 'LABEL_OTHER_SUPPLIES' },
            { id: SupplyCategoryEnum.LinensAndApparel, displayName: this.$translate.instant("LABEL_LINENS_APPAREL_SUPPLIES"), value: SupplyCategoryEnum.Refreshment, label: 'LABEL_LINENS_APPAREL_SUPPLIES' },
            { id: SupplyCategoryEnum.RetailPackaging, displayName: this.$translate.instant("LABEL_RETAIL_PACKAGING_SUPPLIES"), value: SupplyCategoryEnum.Refreshment, label: 'LABEL_RETAIL_PACKAGING_SUPPLIES' },
            { id: SupplyCategoryEnum.Housekeeping, displayName: this.$translate.instant("LABEL_HOUSEKEEPING_SUPPLIES"), value: SupplyCategoryEnum.Refreshment, label: 'LABEL_HOUSEKEEPING_SUPPLIES' },
            { id: SupplyCategoryEnum.FoodAndBeverage, displayName: this.$translate.instant("LABEL_FOOD_BEVERAGE_SUPPLIES"), value: SupplyCategoryEnum.Refreshment, label: 'LABEL_FOOD_BEVERAGE_SUPPLIES' }
        ];
        public isSideBarOpen: boolean = false;
        public orderItemsByList: any[];
        private isDirty: boolean = false;
        public showSideNavDiscount: boolean = false;
        public discountToApply: Model.PurchaseOrderDiscount = {
            type: Meevo.Model.PurchaseOrderDiscountTypeEnum.PercentOff,
            discountValue: 0,
            discountAmount: 0,
            isSpread: false
        };
        public selectedAll: boolean = false;
        public totalItemCount: number = 0;
        public totalPrice: number = 0;
        public totalUndiscountedPriceOfDiscountedItems: number = 0;
        public totalDiscountedPriceOfDiscountedItems: number = 0;
        public totalDiscountsForSelectedItems: number = 0;
        public totalDiscountedLineTotal: number = 0;
        private backupLineItems: PurchaseOrderDetails[];
        private isDistributorChanged: boolean = false;
        public sortOption: string;
        private dateLoadProducts: Date = moment().toDate();
        public isDistributorSelected: boolean = false;
        public emptyGuid: Guid = Guid.empty;

        public manufacturerMoverModel: any = null;
        public productCategoryMoverModel: any = null;
        public supplyCategoryMoverModel: any = null;

        public allManufacturersSelected: boolean = true;
        public allProductCategoriesSelected: boolean = true;
        public allSupplyCategoriesSelected: boolean = true;

        protected meevoSecurityKeys = Meevo.Components.Common.SecurityKeys;

        public MdItemSizeDesktop: number = 55;
        public MdItemSizeMobile: number = 251;
        public MdItemSizeDesktopReceival: number = 55;
        public MdItemSizeMobileReceival: number = 326;
        public MdItemSizeTabletReceival: number = 164;

        public mobileReceivalCardHeight: number = 0;
        public auditHistorySecurityKey = this.securityKeys.MANAGEMENT_AUDITHISTORY;

        protected decimalPrecision: number;
        public tenantEnableProductUsageTracking: boolean = false;

        public isLocationActive: boolean = false;
        public isSalonInteractiveAccountObjectStateActive = false;
        public showExternalOrderingActionSalonInteractive: boolean = false;

        constructor(
            public appSettings: Meevo.Components.Common.IAppSettings,
            public dataService: Meevo.Components.BaseClasses.IDataService,
            public modalService: Meevo.Components.Modal.ModalService,
            public purchaseOrderController: any,
            public securityChecker: Meevo.Components.Common.SecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            public identityService: Meevo.Components.Common.IIdentityService,
            public q: ng.IQService,
            public timeout: ng.ITimeoutService,
            public reportRouterService: Meevo.Components.Common.ReportRouterService,
            public $mdSidenav: any,
            public $translate: ng.translate.ITranslateService,
            public $rootScope: angular.IRootScopeService,
            public $scope: angular.IScope,
            public busyService: Meevo.Components.Busy.IBusyService,
            protected roundingService: Meevo.Components.Common.IRoundingService,
            public $window: ng.IWindowService,
            private lotModalBridge: LotModalBridge) {

            super(appSettings, $rootScope);

            this.DATA_PRODUCT_TAB_MAIN = this.securityKeys.DATA_PRODUCT_TAB_MAIN + this.securityParts.KEY_PART_READ;
            this.mode = Meevo.Model.MaintenanceFormState.Pending;
            this.controller = purchaseOrderController;
            this.$q = q;
            this.$timeout = timeout;
            //this.resetEmailPOValues();
            this.initializePage();

            this.trackingService = trackingService;
            this.buildCrudSecurityKeys(this.securityKeys.INVENTORY_PURCHASEORDER);
            this.addNoteSecurityKey = "INVENTORY:PURCHASEORDERNOTE:WRITE";
            this.editNoteSecurityKey = "INVENTORY:PURCHASEORDERNOTE:EDIT";
            this.deleteNoteSecurityKey = "INVENTORY:PURCHASEORDERNOTE:DELETE";
            this.readNoteSecurityKey = "INVENTORY:PURCHASEORDERNOTE:READ";
            this.$scope.$on('purchaseOrder:isSideBarOpen', (event, val) => {
                this.isSideBarOpen = val;
            });

            this.isAvedaAccountActive();
            this.isSalonInteractiveAccountActive();
            this.fixScrolling();

            this.decimalPrecision = this.appSettings.APP_BUSINFOSETTINGS.generalSettings.inventoryDecimalPrecision || 4;
            this.tenantEnableProductUsageTracking = this.appSettings.APP_BUSINFOSETTINGS.generalSettings.productUsageTracking || false;

            this.$rootScope.$on(Meevo.Components.Common.Messages.EXTERNAL_ORDERING_ACCESS_TOKEN_OBTAINED, (event, msg) => {
                // update the status that it is successful in obtaining the token
                
            });
        }

        initializePage(): void {
            this.width = $(document).width();

            this.initializeDistributors();
            this.initializeManufacturers();
            this.initializeFloorLocations();
            this.resetPurchaseOrder();
            this.getLocationDetail();

            this.topIndex = 0;
            this.includeDiscontinuedProductVariant = false;
            this.virtualMaximum = 0;
            this.isFirstSearch = true;
            this.showResults = false;
            this.showReceival = false;
            this.productVariantFilter = "";
            this.purchaseOrders = [];
            this.purchaseOrderNotes = [];
            this.tempProductList = [];
            this.purchaseOrderNote = {
                id: null,
                purchaseOrderId: "",
                objectState: null,
                note: null,
                poObjectState: null

            };

            this.dataService.getEnumList(Meevo.Model.EnumTypeEnum.ProductInventoryTypeEnum)
                .then((response: any) => {
                    this.productTypes = response;
                });

            var scope = this;
            this.purchaseOrderStates = [];
            this.purchaseOrderStates.push({ "key": 0, "value": this.$translate.instant("LABEL_ALL") });
            this.purchaseOrderStates.push({ "key": this.PurchaseOrderStateEnum.NotReceived, "value": this.$translate.instant("ENUM_LABEL_" + this.PurchaseOrderStateEnum.NotReceived) });
            this.purchaseOrderStates.push({ "key": this.PurchaseOrderStateEnum.PartiallyReceived, "value": this.$translate.instant("ENUM_LABEL_" + this.PurchaseOrderStateEnum.PartiallyReceived) });
            this.purchaseOrderStates.push({ "key": this.PurchaseOrderStateEnum.ReceivedInFull, "value": this.$translate.instant("ENUM_LABEL_" + this.PurchaseOrderStateEnum.ReceivedInFull) });

            this.searchCriteria = {
                "purchaseOrderState": 0,
                productInventoryType: null
            };

            this.productSearchCriteria.productInventoryType = this.purchaseOrder.productInventoryType;
            this.productSearchCriteria.distributorId = this.purchaseOrder.distributorId;
            this.productSearchCriteria.newDistributorId = this.purchaseOrder.distributorId;
            this.productSearchCriteria.manufacturerId = this.purchaseOrder.manufacturerId;
            this.productSearchCriteria.supplyCategoryEnum = this.purchaseOrder.supplyCategoryEnum;
            this.productSearchCriteria.manufacturerIds = this.purchaseOrder.manufacturerIds;
            this.productSearchCriteria.supplyCategoryIds = this.purchaseOrder.supplyCategoryIds;
            this.productSearchCriteria.productSubCategoryIds = this.purchaseOrder.productSubCategoryIds;
            this.productSearchCriteria.excludeItemsAlreadyOnOrder = false;
            this.productSearchCriteria.includeActive = true;
            this.productSearchCriteria.excludeIdList = [];

            this.dateCreatedColumn = { header: this.$translate.instant("LABEL_PURCHASE_ORDER_NUMBER"), fieldName: 'PurchaseOrderNumber', sortDirection: Model.SortDirection.Descending, width: 15 };
            this.customColumns = [
                { header: this.$translate.instant("LABEL_INVENTORY_TYPE"), fieldName: 'productInventoryType', sortDirection: null, width: 15 },
                { header: this.$translate.instant("LABEL_DISTRIBUTOR"), fieldName: 'distributorDisplayName', sortDirection: null, width: 15 },
                { header: this.$translate.instant("LABEL_DIST_REF_NUM"), fieldName: 'referenceNumber', sortDirection: null, width: 10 },
                { header: this.$translate.instant("LABEL_CREATED_BY"), fieldName: 'userDisplayName', sortDirection: null, width: 10 },
                { header: this.$translate.instant('LABEL_PO_NUMBER_ITEM'), fieldName: 'itemCount', sortDirection: null, width: 10 },
                { header: this.$translate.instant("LABEL_PO_ORIGINAL_COST"), fieldName: 'itemTotal', sortDirection: null, width: 10 },
                { header: this.$translate.instant("LABEL_PURCHASE_ORDER_STATE"), fieldName: 'purchaseOrderState', sortDirection: null, width: 15 }
            ];

            this.orderItemsByList = [];
            this.orderItemsByList.push({ "key": "DisplayName", "value": "LABEL_DISPLAY_NAME", "isVisible": true });
            this.orderItemsByList.push({ "key": "ManufacturerName", "value": "LABEL_MANUFACTURER", "isVisible": true });
            this.orderItemsByList.push({ "key": "OrderOfEntry", "value": "LABEL_ORDER_OF_ENTRY", "isVisible": true });
            this.orderItemsByList.push({ "key": "ProductCategory", "value": "LABEL_INPUT_PRODUCT_CATEGORY", "isVisible": true });
            this.orderItemsByList.push({ "key": "VariantSku", "value": "LABEL_SKU_CODE", "isVisible": true });
            this.orderItemsByList.push({ "key": "SupplyCategory", "value": "LABEL_SUPPLY_CATEGORY", "isVisible": false });


            //var request = {
            //    "criteria": {
            //        "coBusinessTypeId": null,
            //        "coFilterByLocationId": null,
            //        "distributorId": null,
            //        "includeActive": true,
            //        "itemPerPage": 5000,
            //        "manufacturerId": null,
            //        "productInventoryType": 2362,
            //        "supplyCategoryEnum": null
            //    },
            //    "itemsPerPage": 5000,
            //    "pageNumber": 0,
            //    "sortBy": null,
            //    "sortDirection": 0
            //};
            //
            //this.dataService.customMethodData("api/PurchaseOrder/Product/List/", "POST", request)
            //    .then((response) => {
            //        this.allVariants = response.data;
            //    });

        }

        scrollToReceivalProduct = (product, isMobile) => {
            // find the index of the very first matching variant
            let ndx = _.findIndex(this.poReceival.receivalLineItems, (item) => { return item.variantId == product.id && item.productInventoryType == product.productInventoryType });
            if (ndx >= 0) {
                this.setScrollTop(ndx, true, isMobile);
                if (ndx == this.poReceival.receivalLineItems.length - 1) {
                    // do this additional one only if it is the last item on the list
                    this.$timeout(() => {
                        this.setScrollTop(ndx, true, isMobile);
                    }, 0);
                }

                this.highlightId = this.getConcatenatedString(product.id, product.productInventoryType);

                this.$timeout(() => {
                    // have the highlightId reset itself after 2 seconds (length of animation)
                    this.highlightId = null;
                }, 2000);
            }

            this.hideList3();
            this.smartSearchFilter3 = '';
        }

        showList3 = () => {
            if (this.smartSearchFilter3 != '') {
                var list = $("[name='list3']");
                list.show();
            }
            else {
                this.hideList3();
            }
        }

        hideList3 = () => {
            var list = $("[name='list3']");
            list.hide();
            this.smartSearchFilter3 = '';
        }

        scrollToProduct = (product: any, isMobile: boolean) => {
            // find the index of the very first matching variant
            let ndx = _.findIndex(this.purchaseOrder.lineItems, (item) => { return item.id == product.id && item.productInventoryType == product.productInventoryType });
            if (ndx >= 0) {
                this.setScrollTop(ndx, false, isMobile);
                if (ndx == this.purchaseOrder.lineItems.length - 1) {
                    // do this additional one only if it is the last item on the list
                    this.$timeout(() => {
                        this.setScrollTop(ndx, false, isMobile);
                    }, 0);
                }

                this.highlightId = this.getConcatenatedString(product.id, product.productInventoryType);

                this.$timeout(() => {
                    // have the highlightId reset itself after 2 seconds (length of animation)
                    this.highlightId = null;
                }, 2000);
            }

            this.hideList2();
            this.smartSearchFilter2 = '';
        }

        setScrollTop = (ndx, forReceivalScreen: boolean = false, isMobile: boolean = false) => {
            var thisParent = forReceivalScreen
                ? document.getElementById("po-receivals")
                : document.getElementsByClassName(isMobile ? "inv-maint-form-wrapper" : "purchase-order-detail-wrapper")[0];
            let clientWidth = document.documentElement.clientWidth;
            let itemClasses = (forReceivalScreen && clientWidth >= 960) ? ".inv-row.receival-mode" : ".inventory-repeat.po-index";
            var el = $(thisParent).find(itemClasses);
            let heightOfItem: number = this.getMdItemSize(forReceivalScreen);
            if (el && el.length > 0) {
                heightOfItem = Math.max(el[0].clientHeight, heightOfItem);
            }

            if (thisParent) {
                let scrollerIndex = ((forReceivalScreen && (clientWidth <= 959 || isMobile)) ? 1 : 0);
                // scroll to top of first item matched
                let el = thisParent.getElementsByClassName("md-virtual-repeat-scroller")[scrollerIndex];
                let newScrollTop: number = ndx <= 0 ? 0 : (ndx * heightOfItem) - 10;
                newScrollTop = newScrollTop > (el.scrollHeight - el.clientHeight) ? (el.scrollHeight - el.clientHeight) : newScrollTop;
                el.scroll({ left: 0, top: newScrollTop, behavior: "smooth" });
            }
        }

        doHighlight = (item) => {
            if (this.highlightId) {
                if (item.variantId) {
                    return (this.getConcatenatedString(item.variantId, item.productInventoryType) == this.highlightId);
                }
                else {
                    return (this.getConcatenatedString(item.id, item.productInventoryType) == this.highlightId);
                }
            }
            return false;
        }
        getConcatenatedString(id, type): string {
            return id + '_' + type;
        }

        filterProductsInDropdown = (val: string) => {
            if (!this.purchaseOrder || !this.purchaseOrder.lineItems || this.purchaseOrder.lineItems.length == 0 || !val) return null;
            var data = this.purchaseOrder.lineItems;
            var reList = _.map(val.split(" "), (w: string) => new RegExp("\\b" + w, "i"));
            return data.filter(x => _.all(reList, (re) => re.test(x.sku)
                || re.test(x.displayName)
                || re.test(x.variantDisplayName)
                || re.test(x.barCode)
                || re.test(x.variantDistributorDisplayName)));
        }

        showPoSearchTypeahead = () => {
            if (this.smartSearchFilter2 != '') {
                var list = $(".po-search-list");
                list.show();
            }
            else {
                this.hideList2();
            }
        }

        hideList2 = () => {
            var list = $("#list2");
            list.hide();
            var list2 = $(".po-search-list");
            list2.hide();
            this.smartSearchFilter2 = '';
        }

        showReceivalList = () => {
            if (this.smartSearchFilter3 != '') {
                var list = $("#receivalList");
                list.show();
            }
            else {
                this.hideReceivalList();
            }
        }

        hideReceivalList = () => {
            var list = $("#receivalList");
            list.hide();
            this.smartSearchFilter3 = '';
        }

        showList = () => {
            if (this.smartSearchFilter != '') {
                var list = $("#list");
                list.show();
            }
        }

        hideList = () => {
            var list = $("#list");
            list.hide();
            this.smartSearchFilter = '';
        }
        showReceivalSidebar = () => {
            var sideBar = this.$mdSidenav('purchaseOrderSidenav');
            if (sideBar) {
                sideBar.open();
                //this.isSideBarOpen = true;
            }
            setTimeout(() => {
                this.$scope.$emit('purchaseOrder:isSideBarOpen', true);
            }, 100);
        }
        hideReceivalSidebar = () => {
            var sideBar = this.$mdSidenav('purchaseOrderSidenav');
            if (sideBar) {
                sideBar.close();
                this.isSideBarOpen = false;
            }

            if (this.$scope.isMobileDevice && this.mode == MaintenanceFormState.Editing) {
                this.showSideNavDiscount = true;
            } else {
                this.selectedAll = false;
                this.showSideNavDiscount = false;
            }
        }
        showDiscounts() {
            this.showSideNavDiscount = true;
            this.calculateDiscountTotals();
            this.showReceivalSidebar();
        }

        toggleDiscountsPanel() {
            (this.showSideNavDiscount = !(this.showSideNavDiscount)) ? this.showReceivalSidebar() : this.hideReceivalSidebar();
            this.calculateDiscountTotals();
        }

        getElement(item: Model.PurchaseOrderDetails) {
            return $("#virtual_productId_" + this.getConcatenatedString(item.id, item.productInventoryType));
        }

        scrollToElement(item: Model.PurchaseOrderDetails, last: boolean = false) {
            let elem = this.getElement(item);
            if (elem != null && elem.length > 0) {
                let ndx = last ? (elem.length - 1) : 0;
                elem[ndx].scrollIntoView();
            }
        }

        selectProductFromTypeAhead = () => {
            var item = this.filterVariant;
            this.filterVariant = null;

            // is first time to add a product onto the PO and PO is new
            if (this.isFirstSearch && Model.Guard.isNothing(this.purchaseOrder.id)) {
                this.purchaseOrder.distributorId = this.productSearchCriteria.distributorId;
                this.purchaseOrder.manufacturerId = this.productSearchCriteria.manufacturerId;
                this.purchaseOrder.productInventoryType = this.productSearchCriteria.productInventoryType;
                this.purchaseOrder.supplyCategoryEnum = this.productSearchCriteria.supplyCategoryEnum;
            }

            this.isFirstSearch = false;

            if (item != null) {
                var ndx = _.findIndex(this.purchaseOrder.lineItems, (li) => {
                    return li.id == item.id && li.productInventoryType == item.productInventoryType && li.orderQuantity > 0;
                });

                if (ndx < 0) { // did not find an item with an order quantity, so let's look for the very first one that matches
                    ndx = _.findIndex(this.purchaseOrder.lineItems, (li) => {
                        return li.id == item.id && li.productInventoryType == item.productInventoryType;
                    });
                }

                var findItem: PurchaseOrderDetails = null;
                if (ndx >= 0) {
                    findItem = this.purchaseOrder.lineItems[ndx];
                }

                if (findItem && (findItem.orderQuantity != 0 || findItem.orderOfEntry != 0 || findItem.dateAdded != null)) {
                    var productVariantName = this.getItemDisplayName(item);
                    var msg = this.$translate.instant("MESSAGE_PO_ADD_VARIANT_MULTI_TIMES", { "productVariantDisplayName": productVariantName, "number": (ndx + 1) });
                    return this.modalService
                        .confirm(msg, Components.Modal.ModalTranslationModes.DoNotTranslate)
                        .then(() => {
                            this.addItemToPurchaseOrder(item);
                            this.highlightAddedItem(item);
                            this.calculateTotals();
                        });
                }

                if (findItem) {
                    // even though it was found in the PO, it was not yet added as an item with quantity
                    findItem.orderQuantity = 1;
                    findItem.lineTotal = this.calculateLineTotal(findItem);
                    findItem.orderOfEntry = 0;
                    findItem.dateAdded = moment().toDate();
                }
                else {
                    this.addItemToPurchaseOrder(item);
                }

                this.highlightAddedItem(item);
                this.calculateTotals();
            }
        }

        highlightAddedItem(item, isMobile: boolean = false) {
            if (this.showResults) {
                this.scrollToElement(item);
            }
            this.$timeout(() => {
                this.scrollToProduct(item, this.$scope.isMobileDevice);
            }, 500);
        }

        addItemToPurchaseOrder(item: Model.PurchaseOrderDetails) {
            // NOTE: this will add to the lineItems only and will not check if it already exists; that should be done before calling this function

            if (!item) {
                return;
            }

            if (item.orderQuantity == 0) {
                item.orderQuantity = 1;
                item.lineTotal = this.calculateLineTotal(item);
            }

            item.orderOfEntry = 0;
            item.dateAdded = moment().toDate();
            item.isNew = true;

            item.onHandDecimalPrecision = this.getOnHandDecimalPrecision(item);

            // US 13009: always add new items to top of the list
            this.purchaseOrder.lineItems.unshift(item);
        }

        CreateIsRetailOrShopSupplyVariable(response, request): any[] {

            if (request.criteria.productInventoryType == ProductInventoryTypeEnum.RetailOrShopSupply && response && response.length > 0) {
                response.forEach(li => {
                    li.isRetailShopSupply = true;
                    li.enumDisplayName = this.$translate.instant("ENUM_LABEL_" + li.productInventoryType);
                });
            }
            return response;
        }

        removeProduct = (index) => {
            this.tempProductList.splice(index);
        }

        loadTempProducts = () => {
            document.getElementById("productSearchBtn").click();
        }

        quantityMode = (changeToQuantityMode) => {
            this.isQuantityMode = changeToQuantityMode;
            this.showStats = false;
        }

        hideOrShowFilter = () => {
            this.showFilter = !this.showFilter;
        }

        showTheFilter(): void {
            this.showFilter = true;
        }

        calculateLineTotal(item: PurchaseOrderDetails): number {
            var total: number = 0;
            if (item) {
                total = this.calculateLineTotalWithValues(item.orderQuantity, item.unitPrice, item.multiplesOf, item.productPackageType);
            }
            return total;
        }

        calculateReceivableLineTotal(item: PoReceivalLineItem, useTotalQuantity: boolean): number {
            var total: number = 0;
            if (item) {
                var quantity: number = item.receiveQuantity;
                if (useTotalQuantity) {
                    quantity = this.roundingService.addNormalizedNumbers(item.receiveQuantity, item.currentReceiveQuantity);
                }
                total = this.calculateLineTotalWithValues(quantity, item.unitPrice, item.multiplesOf, item.productPackageType);
            }
            return total;
        }

        calculateLineTotalWithValues(quantity: number, unitPrice: number, multiplesOf: number, packageType: Meevo.Model.ProductPackageTypeEnum): number {
            var total: number = 0;
            if (multiplesOf && packageType === Meevo.Model.ProductPackageTypeEnum.Case) {
                total = this.roundingService.normalizeDecimalPlaces(unitPrice * this.roundingService.multiplyNormalizedNumbers(multiplesOf, quantity));
            }
            else {
                total = this.roundingService.normalizeDecimalPlaces(unitPrice * quantity);
            }
            return total;
        }

        orderQuantityItemChanged(item: PurchaseOrderDetails): void {
            if (!item || !item.id) return;

            this.isDirty = true;

            if (item.orderOfEntry == 0) {
                if (item.dateAdded == null) {
                    item.dateAdded = this.dateLoadProducts;
                }
            }

            if (item.discounts && item.discounts.length > 0) {
                let totalItemDiscount = 0;
                for (var i = 0, n = item.discounts.length; i < n; i++) {
                    let discount = item.discounts[i];
                    totalItemDiscount = this.roundingService.addNormalizedNumbers(totalItemDiscount, this.calculateLineTotalWithValues(item.orderQuantity, discount.discountAmount, item.multiplesOf, item.productPackageType));
                }
                item.discountAmount = totalItemDiscount;
            }

            this.recalculateTotalPriceWithLineTotal(item);
            this.calculateTotals();

            item.willSave = true;
            var newItemTotal = 0;
            _.each(this.purchaseOrder.lineItems, (li) => newItemTotal += li.orderQuantity);
            this.purchaseOrder.itemTotal = newItemTotal;
        }


        currentReceiveQuantityChanged(item: PoReceivalLineItem): void {
            this.isDirty = true;
            if (item.currentReceiveQuantity == null) {
                item.currentReceiveQuantity = 0;
            }
            //(item.receiveQuantity + item.currentReceiveQuantity) * item.unitPrice;
            item.receivableLineTotal = this.roundingService.normalizeDecimalPlaces(this.roundingService.addNormalizedNumbers(item.receiveQuantity, item.currentReceiveQuantity) * item.unitPrice);
            this.updateReceivalQuantity(item);
        }

        // -----------------------------------------------------------------------------
        // Lot tracking (FA3 PO Lot Modal — ADO 121168)
        //
        // For variants with `trackLots`, the desktop receival grid swaps the quantity
        // spinner for an edit-icon that opens the <meevo-lot-tracking-modal> web
        // component via LotModalBridge. The icon is always rendered; pointer-events
        // + opacity disable interaction when the grid is in read-only view mode
        // (see template: ng-class, ng-style, ng-click gated on !isReadonly()).
        //
        // The icon's tooltip + aria-label are state-varying ("Enter lots" /
        // "Edit lots" / "View lots") via lotTooltipLabel() below — the icon itself
        // is always the same edit glyph per updated design.
        //
        // `lotButtonMode` drives the MODAL's internal mode (editable/partial/readonly)
        // based on PO state + existing allocations.
        //
        // PoReceivalLineItem is now extended with the lot-tracking fields
        // (trackLots, trackExpirationDate, sku, barCode, lotAllocations) in
        // meevo.model.custom.ts. Methods below take a typed `item` rather
        // than `any`.
        // -----------------------------------------------------------------------------

        public lotTooltipLabel(item: PoReceivalLineItem): string {
            if (!item || !item.trackLots) return '';
            if (this.poReceivedInFull()) return this.$translate.instant('LABEL_VIEW_LOTS');
            // "Edit" tooltip if prior RECEIVED lots exist (server-sourced, no
            // _pending flag); "Enter" otherwise — including the case where
            // this session's modal-Apply left pending allocations behind,
            // because those are still editable on re-open.
            const hasReceivedLots = this.hasAnyReceivedLots(item);
            return this.$translate.instant(hasReceivedLots ? 'LABEL_EDIT_LOTS' : 'LABEL_ENTER_LOTS');
        }

        public lotButtonMode(item: PoReceivalLineItem): LotModalMode {
            if (this.poReceivedInFull()) return 'readonly';
            // Mode is 'partial' only when at least one allocation has been
            // RECEIVED (committed to DB via a prior PO-level Save). We detect
            // that by the absence of the client-only _pending flag — see
            // ILotAllocation._pending for the lifecycle. Allocations the user
            // just entered via modal-Apply carry _pending=true and should
            // keep the modal in 'editable' so they can still be revised
            // until Receive All + Save locks them in.
            return this.hasAnyReceivedLots(item) ? 'partial' : 'editable';
        }

        private hasAnyReceivedLots(item: PoReceivalLineItem): boolean {
            const lots = (item && item.lotAllocations) || [];
            return lots.some((a) => a && !a._pending);
        }

        /** Template-facing alias of hasAnyReceivedLots — drives the "View Lots"
         *  magnifier's conditional render in the PO receival grid. */
        public itemHasReceivedLots(item: PoReceivalLineItem): boolean {
            return this.hasAnyReceivedLots(item);
        }

        /** Opens the lot modal in readonly mode regardless of PO state — used by
         *  the magnifier icon in the Received column to let the user inspect
         *  committed allocations without entering edit flow. */
        public openLotModalReadonly(item: PoReceivalLineItem): void {
            this.openLotModal(item, 'readonly');
        }

        public openLotModal(item: PoReceivalLineItem, forcedMode?: LotModalMode): void {
            const mode = forcedMode || this.lotButtonMode(item);
            const lineItem: ILotModalInput = {
                // Discriminator for the modal's LotTrackingLineItem union — the
                // web component's type narrowing keys off `context`.
                context: 'po-receive',
                // Model.PoReceivalLineItem types variantId as `Guid | string`; the
                // bridge's ILotModalInput expects plain `string`. Both Guid values
                // and strings serialize identically at runtime, so the cast is safe.
                variantId: item.variantId as string,
                productInventoryTypeEnum: item.productInventoryType,
                orderOfEntry: item.orderOfEntry,
                // poReceivableHeaderId lives on the receival payload at runtime but is
                // not yet in the PurchaseOrderReceival interface — cast until the model
                // is extended.
                poReceivableHeaderId: (this.poReceival as any).poReceivableHeaderId,
                quantityExpected: item.orderQuantity,
                quantityAlreadyReceived: item.receiveQuantity,
                receiveQuantity: item.currentReceiveQuantity,
                productDisplayName: item.productDisplayName || '',
                variantDisplayName: item.variantDisplayName || '',
                sku: item.sku,
                barCode: item.barCode || '',
                inventoryTypeDisplay: this.$translate.instant('ENUM_LABEL_' + item.productInventoryType),
                trackExpirationDate: !!item.trackExpirationDate,
            };
            const existingAllocations: ILotAllocation[] = item.lotAllocations || [];

            this.lotModalBridge.open(
                lineItem,
                existingAllocations,
                mode,
                (newAllocations) => {
                    // Save-merge contract: the WC emits ALL editable rows
                    // (pending this-session allocations), not a delta. Locked
                    // rows (server-sourced, no _pending flag) never enter the
                    // editable form and are preserved here. This lets the user
                    // re-open the modal and edit/remove a pending allocation
                    // without it reappearing as a phantom from the prior
                    // existingAllocations snapshot.
                    const lockedPrior = (existingAllocations || []).filter(
                        (a) => a && !a._pending,
                    );
                    const newPending = (newAllocations || []).map((a) => {
                        // Stamp _pending=true on modal-emitted rows so
                        // subsequent opens can distinguish them from
                        // server-sourced committed allocations. The flag is
                        // cleared automatically when the server returns fresh
                        // data after a PO-level Save (see ILotAllocation._pending).
                        return Object.assign({}, a, { _pending: true }) as ILotAllocation;
                    });
                    item.lotAllocations = lockedPrior.concat(newPending);
                    item.currentReceiveQuantity = newPending.reduce(
                        (sum: number, a: ILotAllocation) => sum + (a.quantity || 0),
                        0,
                    );
                    this.currentReceiveQuantityChanged(item);
                },
                () => { /* cancelled — no state change */ },
            );
        }

        private poReceivedInFull(): boolean {
            return !!(this.poReceival && this.poReceival.purchaseOrderState === PurchaseOrderStateEnum.ReceivedInFull);
        }

        public hasAnyLotTrackedLines(): boolean {
            const lines = (this.poReceival && this.poReceival.receivalLineItems) || [];
            return lines.some((i) => !!i.trackLots);
        }

        public allLinesLotTracked(): boolean {
            const lines = (this.poReceival && this.poReceival.receivalLineItems) || [];
            return lines.length > 0 && lines.every((i) => !!i.trackLots);
        }

        public receiveAllDisabled(): boolean {
            return this.allLinesLotTracked();
        }

        public receiveAllTooltip(): string | null {
            if (this.hasAnyLotTrackedLines()) {
                return this.$translate.instant('LOT_TRACKED_ITEMS_RECEIVED_INDIVIDUALLY');
            }
            return null;
        }


        //update  po line total when OrderQuantity changed from receival page
        updatePoLineTotalFromReceival(item: PoReceivalLineItem) {
            this.updateQtyOrderedFromReceival(item);

            if (this.purchaseOrder != undefined && this.purchaseOrder.lineItems != undefined && this.purchaseOrder.lineItems.length > 0) {
                var poItem = _.findWhere(this.purchaseOrder.lineItems, { id: item.variantId, productInventoryType: item.productInventoryType, orderOfEntry: item.orderOfEntry });
                if (poItem) {
                    this.recalculateTotalPriceWithLineTotal(poItem);
                }
            }
        }

        updateQtyOrderedFromReceival(item: PoReceivalLineItem) {
            if (item.orderQuantity == 0) {
                // reset orderQuantity to min value 1 when user manually input 0, as we no longer support Qty Ordered to be set to 0 (USER STORY 39373).
                item.orderQuantity = 1;
            }

            if (item.orderQuantity == 0 && (item.receiveQuantity > 0 || item.currentReceiveQuantity > 0)) {
                this.modalService.alert("MESSAGE_PURCHASEORDER_RECEIVAL_EQUALORDERQTY", Meevo.Components.Modal.ModalTranslationModes.Translate);
                item.orderQuantity = item.receiveQuantity + item.currentReceiveQuantity;
            }
        }

        takeBackup(): void {
            this.takeBackupPurchaseOrder();
            this.takeBackupPoReceival();
        }

        takeBackupPurchaseOrder(): void {
            this.backupPurchaseOrder = angular.copy(this.purchaseOrder);
        }

        takeBackupPoReceival(): void {
            this.backupPoReceival = angular.copy(this.poReceival);
        }

        resetPurchaseOrderChanges(): void {
            this.purchaseOrder = angular.copy(this.backupPurchaseOrder);
            this.poReceival = angular.copy(this.backupPoReceival);
        }

        restoreVisibility(): void {
            this.showResults = true;
        }

        createNewCount(): void {
            this.mode = MaintenanceFormState.Adding;
            this.showResults = false;
            this.showTheFilter();
            this.$timeout(() => {
                this.showReceivalSidebar();
            }, 150);

        }

        supplyCategoryChanged() {
            this.purchaseOrderProductSearchCriteria.supplyCategoryEnum = this.productSearchCriteria.supplyCategoryEnum;
        }

        manufacturerChanged() {
            this.purchaseOrderProductSearchCriteria.manufacturerId = this.productSearchCriteria.manufacturerId;
        }

        excludeItemsAlreadyOnOrderChecked() {
            this.purchaseOrderProductSearchCriteria.excludeItemsAlreadyOnOrder = this.productSearchCriteria.excludeItemsAlreadyOnOrder;
        }

        productInventoryTypeChanged() {
            this.removePurchaseOrderLineItems();
            this.showResults = false;
            this.purchaseOrderProductSearchCriteria.productInventoryType = this.productSearchCriteria.productInventoryType;
            this.setSortOption(this.productSearchCriteria.productInventoryType);
        }

        view(): void {
            this.lockSort = false;
            this.isDirty = false;
            this.isDistributorChanged = false;

            var promise: ng.IPromise<any>;
            if (this.purchaseOrder.id == null) {
                promise = this.modalService.confirmHandler("LABEL_CONFIRM_PO_CLOSING", Meevo.Components.Modal.ModalTranslationModes.Translate);
            }
            else {
                promise = this.$q.resolve(true);
            }
            promise.then((response: boolean) => {
                if (response) {
                    this.mode = MaintenanceFormState.Pending;
                    this.showResults = false;
                    this.isFirstSearch = true;
                    this.hideReceivalSidebar();
                    this.hideList();
                    this.hideList2();
                    this.hideList3();
                    this.poReceival = null;
                    this.purchaseOrder = null;

                    this.productSearchCriteria.productInventoryType = Meevo.Model.ProductInventoryTypeEnum.Retail;
                    this.productSearchCriteria.distributorId = null;
                    this.productSearchCriteria.newDistributorId = null;
                    this.productSearchCriteria.manufacturerId = null;
                    this.productSearchCriteria.supplyCategoryEnum = null;
                    this.productSearchCriteria.manufacturerIds = [];
                    this.productSearchCriteria.supplyCategoryIds = [];
                    this.productSearchCriteria.productSubCategoryIds = [];
                    this.productSearchCriteria.excludeItemsAlreadyOnOrder = false;
                    this.productSearchCriteria.includeActive = true;
                    this.productSearchCriteria.excludeIdList = [];

                    this.allManufacturersSelected = true;
                    this.allProductCategoriesSelected = true;
                    this.allSupplyCategoriesSelected = true;

                    this.manufacturerMoverModel = null;
                    this.productCategoryMoverModel = null;
                    this.supplyCategoryMoverModel = null;
                    this.$timeout(() => {
                        $("#purchaseOrderSearch").click();
                    }, 1);
                }
            })
                .catch(() => {
                    this.calculateTotals();
                });
        }

        edit(isFromReceival: boolean = false): void {
            //show message if po already submitted to aveda/salon interactive
            var promise: ng.IPromise<any> = null;
            if (this.purchaseOrder && this.purchaseOrder.dateSubmitted && this.purchaseOrder.id) {
                if (this.purchaseOrder.isAvedaOrderingEnabled) {
                    promise = this.modalService.message('MESSAGE_PO_SUBMITTED_TOAVEDA', Meevo.Components.Modal.ModalTranslationModes.Translate);
                }
                else if (this.purchaseOrder.salonInteractiveDistributorId) {
                    promise = this.modalService.message('MESSAGE_PO_SUBMITTED_TO_SALON_INTERACTIVE', Meevo.Components.Modal.ModalTranslationModes.Translate);
                }
            }
            if (promise == null) {
                promise = this.$q.resolve();
            }
            promise.then(() => {
                this.mode = MaintenanceFormState.Editing;
                this.showResults = false;
                if (this.showSideNavDiscount) {
                    this.hideReceivalSidebar();
                }
            });
        }
        viewReadonly(): void {
            this.mode = MaintenanceFormState.Readonly;
            this.lockSort = false;
            this.showResults = false;
            this.isFirstSearch = true;
            this.isDirty = false;
            this.isDistributorChanged = false;
            this.purchaseOrder = angular.copy(this.backupPurchaseOrder);
        }

        cancel(): void {
            if (this.mode != Meevo.Model.MaintenanceFormState.Pending) {
                this.mode = MaintenanceFormState.Readonly;
                this.lockSort = false;
                this.showResults = false;
                this.isFirstSearch = true;
                this.isDirty = false;
                this.isDistributorChanged = false;

                this.purchaseOrder = angular.copy(this.backupPurchaseOrder);
                this.poReceival = angular.copy(this.backupPoReceival);
                this.calculateTotals();
                this.sortOption = this.purchaseOrder.sortOption;

                this.showSideNavDiscount = false;
                this.productSearchCriteria.productInventoryType = this.purchaseOrder.productInventoryType;
                this.productSearchCriteria.distributorId = this.purchaseOrder.distributorId;
                this.productSearchCriteria.newDistributorId = this.purchaseOrder.distributorId;
                this.productSearchCriteria.manufacturerId = this.purchaseOrder.manufacturerId;
                this.productSearchCriteria.supplyCategoryEnum = this.purchaseOrder.supplyCategoryEnum;
                this.productSearchCriteria.manufacturerIds = this.purchaseOrder.manufacturerIds;
                this.productSearchCriteria.supplyCategoryIds = this.purchaseOrder.supplyCategoryIds;
                this.productSearchCriteria.productSubCategoryIds = this.purchaseOrder.productSubCategoryIds;
            }
        }

        isAdding(): boolean {
            if (this.mode == MaintenanceFormState.Adding)
                return true;
            else
                return false;
        }

        isEditing(): boolean {
            if (this.mode == MaintenanceFormState.Editing)
                return true;
            else
                return false;
        }

        isReadonly(): boolean {
            if (this.mode == MaintenanceFormState.Readonly)
                return true;
            else
                return false;
        }

        isPending(): boolean {
            if (this.mode == MaintenanceFormState.Pending)
                return true;
            else
                return false;
        }

        isSecurityDenyOrGrant(key): boolean {
            return this.securityChecker.hasSecurityDenyOrGrant(key);
        }

        pageNoteOrigin(page: number) {
            this.notePageNumber = page;
            this.viewNotes = true;
        }

        pageRecievalOrigin(page: number) {
            if (page == 1) {
                this.mode = MaintenanceFormState.Readonly;
            }
            this.recivalpageNumber = page;
            this.viewNotes = false;
        }

        cancelReceivalPage() {
            if (this.recivalpageNumber == 1) {//show PO search page
                this.mode = MaintenanceFormState.Pending;
                this.showResults = false;
                // this.isFirstSearch = true;
                this.$timeout(() => {
                    $("#purchaseOrderSearch").click();
                }, 1);
            }
            this.hideList();
            this.hideList2();
            this.hideList3();
            if (this.poReceival) {
                this.poReceival.receivalLineItems = [];
            }
            this.showReceival = false;
            this.viewNotes = false;
        }

        backFromNote() {
            if (this.notePageNumber == 1) {//show PO search page
                this.mode = MaintenanceFormState.Pending;
                this.showReceival = false;
            }
            else if (this.notePageNumber == 2) {  //show the page list item
                this.mode = MaintenanceFormState.Readonly;
                this.showReceival = false;
            }
            else if (this.notePageNumber == 3) {  // show receival page
                this.showReceival = true;
            }

            this.viewNotes = false;
        }

        showInformation(prod: any) {
            let modalOptions: Meevo.Plugins.Product.ProductInfoModalOptions = {
                parentType: Meevo.Plugins.Product.ProductInfoModalParent.PurchaseOrder,
                productId: prod.productId,
                variantId: prod.id,
                productInventoryTypeEnum: prod.productInventoryType
            }

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/product/modals/productInformation.template.html",
                controller: "meevo.plugins.product.ProductInformationController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    options: modalOptions
                }
            };
            return this.modalService.showCustom(options);
        }

        emailPO() {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/purchaseOrder/sectionViews/emailPurchaseOrder.modal.html",
                controller: "meevo.plugins.purchaseOrder.PurchaseOrderController",
                controllerAs: "purchaseOrderController",
                bindToController: true,
                locals: {
                    purchaseOrder: this.purchaseOrder
                }
            };
            this.modalService.showCustom(options);
            //this.resetEmailPOValues();
        }

        resetEmailPOValues(getDistributorEmail: boolean = true): void {
            this.emailSection = 0;
            this.emailTo = "";
            this.emailList = [""];
            this.emailSubject = "";
            this.emailBody = "";
            this.emailFileType = "pdf";
            if (getDistributorEmail && this.purchaseOrderController.locals.purchaseOrder.distributorId != null) {
                this.dataService.customMethodData("api/distributor/" + this.purchaseOrderController.locals.purchaseOrder.distributorId, "GET", null).then((d) => {
                    if (d.data && d.data.emailAddress) {
                        this.emailList[0] = d.data.emailAddress;
                    }
                });
            }
        }

        addToEmailList(): void {
            if (this.emailList.length < 10)
                this.emailList.push("");
        }

        removeFromEmailList(index): void {
            this.emailList.splice(index, 1);
        }

        changeEmailPOList(): void {
            this.emailSection = 0;
        }

        validateEmail(email, index): boolean {
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            var isEmailUnique = true;
            for (var i = 0; i < this.emailList.length; i++) {
                // check if any email is the same
                if (this.emailList[i] == email && i != index) {
                    isEmailUnique = false;
                }
            }

            return (re.test(email) && isEmailUnique);
        }

        areAtleastTwoEmailsValid(): boolean {
            var amountOfValidEmails = 0;
            for (var i = 0; i < this.emailList.length; i++) {
                // check if string is valid email
                if (this.validateEmail(this.emailList[i], i)) {
                    amountOfValidEmails++;
                }
            }
            return (amountOfValidEmails >= 2); // all emails are valid
        }

        areAllEmailsValid(): boolean {
            for (var i = 0; i < this.emailList.length; i++) {
                // check if strings are valid emails
                if (!this.validateEmail(this.emailList[i], i)) {
                    return false;
                }

                // check if any strings are the same
                for (var j = i + 1; j < this.emailList.length; j++) {
                    if (this.emailList[i] == this.emailList[j]) {
                        return false;
                    }
                }
            }
            return true; // all emails are valid
        }

        createSubjectAndBody(): void {
            var areAllEmailInputsFilledOutCorrectly = this.areAllEmailsValid();

            if (areAllEmailInputsFilledOutCorrectly) {
                this.emailSubject = this.$translate.instant("MESSAGE_PO_NUMBER") + this.purchaseOrderController.locals.purchaseOrder["purchaseOrderNumber"] + " from " + this.identityService["identity"].locationName;
                this.emailBody = this.$translate.instant("MESSAGE_PLEASE_FIND_ATTACHED_PO_IN_EMAIL") + this.purchaseOrderController.locals.purchaseOrder["purchaseOrderNumber"];
                this.emailSection = 1;
            }
        }

        sendEmail(): void {
            if (this.emailSubject != "" && this.emailBody != "") {

                var reportParams = "{" +
                    "\"ViewPurchaseOrdersReportBy\":\"InvoiceMode\"," +
                    "\"SortPurchaseOrderReportBy\":\"Distributor\"," +
                    "\"DisplayOnHandAmounts\":\"False\"," +
                    "\"DistributorPOMoverList_TBL\":[]," +
                    "\"PurchaseOrdersMoverList_TBL\":[\"" + this.purchaseOrderController.locals.purchaseOrder.id + "\"]," +
                    "\"PurchaseOrderStartDate\":\"" + moment(this.purchaseOrderController.locals.purchaseOrder.dateCreated).startOf("day").format("YYYY-MM-DD HH:mm:ss.SSS") + "\"," +
                    "\"PurchaseOrderEndDate\":\"" + moment(this.purchaseOrderController.locals.purchaseOrder.dateCreated).endOf("day").format("YYYY-MM-DD HH:mm:ss.SSS") + "\"" +
                    "}";

                var reportId = 46;
                var url = `${this.identityService.current().systemSettings.reportsUrl}Report/ExportAndEmail`;
                var mimeType = "";
                switch (this.emailFileType.toLowerCase()) {
                    case "xls":
                    case "xlsx":
                        mimeType = "application/vnd.ms-excel";
                        break;
                    case "rtf":
                    case "doc":
                    case "docx":
                        mimeType = "application/msword";
                        break;
                    case "pdf":
                        mimeType = "application/pdf";
                        break;
                    case "csv":
                        mimeType = "text/csv";
                        url = "/api/ReportExporter/Email";
                        reportId = 243;
                        var columnsToAdd = [{
                            columnName: "ItemDisplayName"
                            , dbType: "System.String"
                            , expression: "SKU + ' : ' + ProductDisplayName + IIF(VariantDisplayName is null,'',' - ' + VariantDisplayName)" 
                        }, {
                            columnName: "UnitPrice"
                            , dbType: "System.Decimal"
                            , expression: "LineTotal / OrderQuantity"
                            }];                        
                        var columnsToExport = [{
                            columnName: "#LINENUMBER#"
                            , displayName: "Line #"
                        }, {
                            columnName: "ItemDisplayName"
                            , displayName: "Item"
                        }, {
                            columnName: "Barcode"
                            , displayName: "Barcode"
                        }, {
                            columnName: "Description"
                            , displayName: "Description"
                        }, {
                            columnName: "OrderQuantity"
                            , displayName: "QTY Ordered"
                        }, {
                            columnName: "UnitPrice"
                            , displayName: "Unit Price"
                        }, {
                            columnName: "LineTotal"
                            , displayName: "Line Total"
                        }, {
                            columnName: "PurchaseOrderNumber"
                            , displayName: "PO #"
                        }];

                        if (this.purchaseOrderController.locals.purchaseOrder.distributorId && this.purchaseOrderController.locals.purchaseOrder.distributorId !== null) {
                            columnsToExport.splice(1, 0, {
                                columnName: "VariantDistributorDisplayName"
                                , displayName: "Dist Prod ID"
                            });
                            columnsToExport.splice(8, 0, {
                                columnName: "DistributorAccountNumber"
                                , displayName: "Account #"
                            });
                        }

                        reportParams = "{" +
                            "\"PurchaseOrderId\":\"" + this.purchaseOrderController.locals.purchaseOrder.id + "\"," +
                            "\"PageNumber\":0," +
                            "\"ItemsPerPage\":100000," +
                            "\"FieldOrderBy\":\"" + this.purchaseOrderController.locals.purchaseOrder.sortOption + "\"," +
                            "\"ColumnsToAdd\":" + JSON.stringify(columnsToAdd) + "," +
                            "\"ColumnsToExport\":" + JSON.stringify(columnsToExport) +
                            "}";
                        break;
                    default:
                        // something went wrong
                        return;
                }

                var parameterData = {
                    "reportId": reportId,
                    "reportParams": reportParams,
                    "reportFormat": this.emailFileType,
                    "reportContentType": mimeType,
                    "sessionId": this.identityService.current().sessionId,
                    "entityId": this.purchaseOrderController.locals.purchaseOrder.id,
                    "emailList": this.emailList,
                    "subject": this.emailSubject,
                    "body": this.emailBody,
                    "fileName": "PurchaseOrder_" + String(this.purchaseOrderController.locals.purchaseOrder.purchaseOrderNumber).replace(" ", "") + "." + this.emailFileType,
                    "isCsvExport": (mimeType == "text/csv")
                };

                if (!parameterData.isCsvExport) {
                    url += `?sessionId=${parameterData.sessionId}`;
                }

                this.busyService.start();
                this.dataService.customMethodData(url, "POST", parameterData).then((d) => {
                    // if email is successfully sent then move to the last modal section
                    if (d.data.isSuccess) {
                        if (d.data.failedToSendEmailToList && d.data.failedToSendEmailToList.length && d.data.failedToSendEmailToList.length > 0) {
                            for (var i = 0; i < this.emailList.length; i++) {
                                for (var j = 0; j < d.data.failedToSendEmailToList.length; j++) {
                                    if (this.emailList[i] == d.data.failedToSendEmailToList[j]) {
                                        this.emailList.splice(i, 1);
                                    }
                                }
                            }
                        }
                        this.emailSection = 2;
                    }
                    else {
                        this.busyService.stop();
                        this.modalService.alert("Sending of Purchase Order was unsuccessful.", Components.Modal.ModalTranslationModes.DoNotTranslate, true);
                    }
                }).finally(() => {
                    this.busyService.stop();
                });

            }
            else {
                if (this.emailSubject == "") {
                    $("#emailSubject").addClass("item-highlight");
                    this.$timeout(() => { $("#emailSubject").removeClass("item-highlight"); }, 1500);
                }
                if (this.emailBody == "") {
                    $("textarea").addClass("item-highlight");
                    this.$timeout(() => { $("textarea").removeClass("item-highlight"); }, 1500);
                }
            }
        }

        closePOEmailModal(): void {
            this.modalService.hide();
            this.resetEmailPOValues(false);
        }

        closeCustomModal(): void {
            this.modalService.hide();
            this.getNotes(this.poReceival.purchaseOrderId, 2026)
        }

        setupProductSearchCriteria(): void {
            if (this.purchaseOrder.productInventoryType === ProductInventoryTypeEnum.Other) {
                this.purchaseOrder.manufacturerId = null;
            }
            else {
                this.purchaseOrder.supplyCategoryEnum = null;
            }

            this.purchaseOrderProductSearchCriteria.productInventoryType = this.productSearchCriteria.productInventoryType = this.purchaseOrder.productInventoryType;
            this.purchaseOrderProductSearchCriteria.distributorId = this.productSearchCriteria.distributorId = this.purchaseOrder.distributorId;
            this.purchaseOrderProductSearchCriteria.manufacturerId = this.productSearchCriteria.manufacturerId = this.purchaseOrder.manufacturerId;
            this.purchaseOrderProductSearchCriteria.supplyCategoryEnum = this.productSearchCriteria.supplyCategoryEnum = this.purchaseOrder.supplyCategoryEnum;
            this.purchaseOrderProductSearchCriteria.manufacturerIds = this.productSearchCriteria.manufacturerIds = this.purchaseOrder.manufacturerIds;
            this.purchaseOrderProductSearchCriteria.supplyCategoryIds = this.productSearchCriteria.supplyCategoryIds = this.purchaseOrder.supplyCategoryIds;
            this.purchaseOrderProductSearchCriteria.productSubCategoryIds = this.productSearchCriteria.productSubCategoryIds = this.purchaseOrder.productSubCategoryIds;
            this.purchaseOrderProductSearchCriteria.excludeItemsAlreadyOnOrder = this.productSearchCriteria.excludeItemsAlreadyOnOrder = false;

            this.allManufacturersSelected = (this.purchaseOrder.manufacturerIds.length == 0);
            this.allProductCategoriesSelected = (this.purchaseOrder.productSubCategoryIds.length == 0);
            this.allSupplyCategoriesSelected = (this.purchaseOrder.supplyCategoryIds.length == 0);

            this.manufacturerMoverModel = { manufacturerIds: angular.copy(this.purchaseOrder.manufacturerIds) };
            this.supplyCategoryMoverModel = { supplyCategoryIds: angular.copy(this.purchaseOrder.supplyCategoryIds) };
            this.productCategoryMoverModel = { productSubCategoryIds: angular.copy(this.purchaseOrder.productSubCategoryIds) };

            this.productSearchCriteria.newDistributorId = this.purchaseOrder.distributorId;
            this.productSearchCriteria.purchaseOrderId = this.purchaseOrder.id;
            this.isDistributorSelected = true;
        }

        initializeFloorLocations(): ng.IPromise<any> {
            return this.dataService.customMethodData("api/FloorLocation/List", "GET", null).then((d) => {
                this.floorLocations = [];
                this.floorLocations.push({ "key": null, "value": "LABEL_ALL_LOCATIONS" });
                for (var i = 0; i < d.data.length; i++) {
                    var location = { "key": d.data[i].id, "value": d.data[i].displayName };
                    this.floorLocations.push(location);
                }
            });
        }

        initializeDistributors(): ng.IPromise<any> {
            var searchCriteria = {
                criteria: {
                    includeActive: true,
                    includeDeleted: false,
                    includeInactive: false
                },
                itemsPerPage: 10000,
                pageNumber: 0
            }
            return this.dataService.customMethodData("api/Distributor/List", "POST", searchCriteria).then((d) => {
                this.distributors = [];
                this.distributors.push({ "key": null, "value": "LABEL_ALL_DISTRIBUTORS" });
                for (var i = 0; i < d.data.length; i++) {
                    var distributor = {
                        "key": d.data[i].id,
                        "value": d.data[i].displayName,
                        "isAvedaOrderingEnabled": d.data[i].isAvedaOrderingEnabled,
                        "salonInteractiveDistributorId": d.data[i].salonInteractiveDistributorId };
                    this.distributors.push(distributor);
                }
            });
        }
        initializeManufacturers(): ng.IPromise<any> {
            var searchCriteria = {
                criteria: {
                    includeActive: true,
                    includeDeleted: false,
                    includeInactive: false
                },
                itemsPerPage: 10000,
                pageNumber: 0
            }

            return this.dataService.customMethodData("api/manufacturer/List/", "POST", searchCriteria).then((d) => {
                this.manufacturers = [];
                this.manufacturers.push({ "key": null, "value": "LABEL_ALL_MANUFACTURERS" });
                for (var i = 0; i < d.data.length; i++) {
                    var manufacturer = { "key": d.data[i].id, "value": d.data[i].displayName };
                    this.manufacturers.push(manufacturer);
                }
            });
        }

        updateDistributor() {
            if (this.purchaseOrder.id && this.productSearchCriteria.newDistributorId != this.purchaseOrder.distributorId && this.productSearchCriteria.newDistributorId != null) {
                this.validateDistributorUpdate();
            }
            else {
                if (this.productSearchCriteria.newDistributorId == Guid.empty) {
                    return;
                }
                else if (!this.isDistributorSelected) {
                    this.isDistributorSelected = true; /* isDistributorSelected atleast once */
                }

                if (this.getItemCount() == 0) { /* When Order Quantity isn't changed */
                    this.setDistributor();
                    if (Model.Guard.isNothing(this.purchaseOrder.id) && this.productSearchCriteria.newDistributorId != null) {
                        this.purchaseOrder.lineItems = [];
                    }
                }
                else {
                    this.validateDistributorUpdate();
                }
            }
        }

        private validateDistributorUpdate() {
            if (this.productSearchCriteria.newDistributorId != this.purchaseOrder.distributorId && this.productSearchCriteria.newDistributorId != null) {
                var distributor: any = _.findWhere(this.distributors, { key: this.productSearchCriteria.newDistributorId });
                var msg = this.$translate.instant('MESSAGE_DISTRIBUTOR_CHANGE', { "newDistributor": distributor.value });
                return this.modalService.warning(msg, Meevo.Components.Modal.ModalTranslationModes.Translate, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                    .then((res: boolean) => {
                        if (res) {
                            this.busyService.start();
                            this.isDistributorChanged = !!(this.purchaseOrder.id);
                            this.setDistributor();

                            if (this.purchaseOrder.id) {
                                var variantIds: any[] = [];
                                return this.getVariantsForNewDistributor(0, variantIds)
                                    .then(() => {
                                        variantIds = variantIds.sort();
                                        // update purchase order lineItems to remove any items not in variantIds
                                        for (var ndx = this.purchaseOrder.lineItems.length - 1; ndx >= 0; ndx--) {
                                            if (_.indexOf(variantIds, this.purchaseOrder.lineItems[ndx].id) < 0) {
                                                this.purchaseOrder.lineItems.splice(ndx, 1);
                                            }
                                        }
                                        this.backupLineItems = angular.copy(this.purchaseOrder.lineItems);
                                        this.calculateTotals();
                                    })
                                    .finally(() => {
                                        this.busyService.stop();
                                    });
                            }
                            else {
                                var existingLineItems = angular.copy(this.purchaseOrder.lineItems);
                                this.isDirty = false;
                                return this.search(true)
                                    .then(() => {
                                        // update purchase order lineItems to remove any items not in variantIds
                                        for (var ndx = this.purchaseOrder.lineItems.length - 1; ndx >= 0; ndx--) {
                                            let oldLineItems = _.where(existingLineItems, { id: this.purchaseOrder.lineItems[ndx].id, productInventoryType: this.purchaseOrder.lineItems[ndx].productInventoryType });
                                            if (oldLineItems && oldLineItems.length > 0) {
                                                this.purchaseOrder.lineItems.splice(ndx, 1, ...oldLineItems);
                                                this.isDirty = true;
                                                existingLineItems = _.without(existingLineItems, ...oldLineItems);
                                            }
                                        }
                                        this.backupLineItems = angular.copy(this.purchaseOrder.lineItems);
                                        this.calculateTotals();
                                    })
                                    .finally(() => {
                                        this.busyService.stop();
                                    });
                            }
                        }
                    })
                    .catch(() => {
                        // reset newDistributorId to old value (distributorId)
                        this.productSearchCriteria.newDistributorId = this.productSearchCriteria.distributorId;
                    });
            }
            else {
                this.setDistributor();
                return this.$q.resolve();
            }
        }

        setDistributor() {
            let d: any = _.findWhere(this.distributors, { key: this.productSearchCriteria.newDistributorId });
            this.showExternalOrderingAction = d && d.isAvedaOrderingEnabled;
            this.showExternalOrderingActionSalonInteractive = d && d.salonInteractiveDistributorId != null
                && this.isSalonInteractiveAccountObjectStateActive
                && this.isLocationActive;

            this.purchaseOrder.distributorId = this.productSearchCriteria.newDistributorId;
            this.productSearchCriteria.distributorId = this.productSearchCriteria.newDistributorId;
            this.purchaseOrderProductSearchCriteria.distributorId = this.productSearchCriteria.newDistributorId;
        }

        getVariantsForNewDistributor(pageNumber, variantIds: any[]): ng.IPromise<any> {
            var request: Model.SearchPage<Guid, any> = {
                pageNumber: pageNumber,
                itemsPerPage: 1000,
                criteria: {
                    purchaseOrderId: this.purchaseOrder.id,
                    distributorId: this.purchaseOrder.distributorId
                }
            };
            return this.dataService.getListPaged("PurchaseOrder", request, this.purchaseOrder.id, "Distributor/Change")
                .then((data) => {
                    if (data) {
                        variantIds.push(...data);
                        if (data.length >= 1000) {
                            return this.getVariantsForNewDistributor(pageNumber++, variantIds);
                        }
                    }
                });
        }

        getItemCount(): number {
            if (this.purchaseOrder == null)
                return 0;
            else if (this.purchaseOrder.lineItems == null)
                return 0;
            else {
                var total = 0;
                for (var i = 0; i < this.purchaseOrder.lineItems.length; i++) {
                    var thisItem = this.purchaseOrder.lineItems[i];

                    // treats items in a case individually
                    //total += thisItem.productPackageType === Meevo.Model.ProductPackageTypeEnum.Case ? thisItem.orderQuantity * thisItem.multiplesOf : thisItem.orderQuantity;

                    // treats a case as one regardless of how many inside
                    total += thisItem.orderQuantity;
                }

                return total;
            }
        }

        getItemTotalPrice(): number {
            if (this.purchaseOrder == null)
                return 0;
            else if (this.purchaseOrder.lineItems == null)
                return 0;
            else {
                var total = 0;
                for (var i = 0; i < this.purchaseOrder.lineItems.length; i++) {
                    // total += this.purchaseOrder.lineItems[i].lineTotal;
                    total = this.roundingService.addNormalizedNumbers(total, this.purchaseOrder.lineItems[i].lineTotal);
                }
                return total;
            }
        }

        getItemUnitPrice(item): number {
            if (!item) {
                return 0;
            }

            var numItems: number = 0;
            if (item.productPackageType == Meevo.Model.ProductPackageTypeEnum.Case && item.multiplesOf > 0) {
                // item.orderQuantity * item.multiplesOf
                numItems = this.roundingService.multiplyNormalizedNumbers(item.orderQuantity, item.multiplesOf);
            }
            else {
                numItems = item.orderQuantity;
            }

            // do not use the normalize function; we need the decimal places on the unit price
            //return this.roundingService.divideNormalizedNumbers(item.lineTotal, numItems);
            return item.lineTotal / numItems;
        }


        getLineTotal(item) {
            return this.calculateLineTotal(item);
        }

        rollBackUnitPrice(item: PurchaseOrderDetails, isDisabled) {
            if (isDisabled) {
                return;
            }
            this.isDirty = true;
            item.unitPrice = item.wholeSale;
            item.discounts = [];
            item.discountAmount = null;

            this.recalculateTotalPriceWithLineTotal(item);
            this.calculateTotals();
        }


        firstSearchComplete(): void {
            this.isFirstSearch = false;
        }

        resetPurchaseOrder(): void {
            this.purchaseOrder = {
                id: null,
                distributorId: null,
                dateCreated: null,
                dateUpdated: null,
                entityVersion: 0,
                productInventoryType: ProductInventoryTypeEnum.Retail,
                itemCount: null,
                itemTotal: 0,
                lineItems: null,
                purchaseOrderState: null,
                userName: '',
                objectState: null,
                notes: null,
                totalPrice: 0,
                autoGeneratePONumber: false,
                manufacturerId: null,
                supplyCategoryEnum: null,
                totalDiscount: 0,
                manufacturerIds: [],
                productSubCategoryIds: [],
                supplyCategoryIds: []
            };
            this["poReceival"] = this.emptyPoReceival;
            this.calculateTotals();

            this.allManufacturersSelected = true;
            this.allProductCategoriesSelected = true;
            this.allSupplyCategoriesSelected = true;

            this.manufacturerMoverModel = null;
            this.productCategoryMoverModel = null;
            this.supplyCategoryMoverModel = null;

            this.isDistributorSelected = false;
        }

        setPurchaseOrderDefaults(): ng.IPromise<any> {
            this.purchaseOrderProductSearchCriteria.productInventoryType = Meevo.Model.ProductInventoryTypeEnum.Retail;
            this.purchaseOrderProductSearchCriteria.distributorId = null;
            this.purchaseOrderProductSearchCriteria.manufacturerId = null;
            this.purchaseOrderProductSearchCriteria.supplyCategoryEnum = null;
            this.purchaseOrderProductSearchCriteria.manufacturerIds = [];
            this.purchaseOrderProductSearchCriteria.supplyCategoryIds = [];
            this.purchaseOrderProductSearchCriteria.productSubCategoryIds = [];

            this.allManufacturersSelected = true;
            this.allProductCategoriesSelected = true;
            this.allSupplyCategoriesSelected = true;

            this.manufacturerMoverModel = { manufacturerIds: [] };
            this.productCategoryMoverModel = { productCategoryIds: [], productSubCategoryIds: [] };
            this.supplyCategoryMoverModel = { supplyCategoryIds: [] };

            this.setSortOption(this.purchaseOrderProductSearchCriteria.productInventoryType);

            return this.dataService.customMethodData("api/PurchaseOrder/Template", "GET", null).then((d) => {
                this.purchaseOrder = d.data;
                this.purchaseOrder.productInventoryType = 2362;
                this.purchaseOrder.distributorId = null;
                this.purchaseOrder.manufacturerId = null;
                this.purchaseOrder.supplyCategoryEnum = null;
                this.purchaseOrder.manufacturerIds = [];
                this.purchaseOrder.supplyCategoryIds = [];
                this.purchaseOrder.productSubCategoryIds = [];
                this.sortOption = this.purchaseOrder.sortOption = "OrderOfEntry";
            });
        }

        selectPurchaseOrder(poId: Guid): ng.IPromise<any> {
            if (!poId) return;

            this.purchaseOrder = null;
            this.backupPurchaseOrder = null;

            return this.dataService.customMethodData("api/PurchaseOrder/" + poId + "?IncludeNote=true&IncludeLineItem=true", "GET", null).then((d) => { //IncludeLineItem=true
                this.purchaseOrder = d.data;
                this.sortOption = this.purchaseOrder.sortOption;

                // force the value to become null so that the drop down list is already selected to All Products
                if (d.data.distributorId == null)
                    this.purchaseOrder.distributorId = null;
                if (d.data.manufacturerId == null)
                    this.purchaseOrder.manufacturerId = null;
                if (d.data.supplyCategoryEnum == null)
                    this.purchaseOrder.supplyCategoryEnum = null;

                if (d.data.manufacturerIds == null)
                    this.purchaseOrder.manufacturerIds = [];
                if (d.data.productSubCategoryIds == null)
                    this.purchaseOrder.productSubCategoryIds = [];
                if (d.data.supplyCategoryIds == null)
                    this.purchaseOrder.supplyCategoryIds = [];

                this.purchaseOrder.lineItems.forEach((item: PurchaseOrderDetails) => {
                    item.onHandDecimalPrecision = this.getOnHandDecimalPrecision(item);
                });

                this.isFirstSearch = true;
                this.includeDiscontinuedProductVariant = false;
                this.setupProductSearchCriteria();
                this.calculateTotals();
                this.setSortOption(this.purchaseOrder.productInventoryType);
                this.setupShowExternalOrderingAction();

                this.takeBackupPurchaseOrder();
                return this.showAuditHistory().then(() => { return this.purchaseOrder; });
            });
        }


        searchForPurchaseOrders(state: PurchaseOrderStateEnum): ng.IPromise<any> {
            var data = { "criteria": { "state": state } };
            return this.dataService.customMethodData("api/PurchaseOrder/List", "POST", data).then((d) => {
                this.purchaseOrders = d.data;
            });
        }

        deleteNote(note): void {
            var scope = this;
            if (note != null && !note.isDistributorNote) {
                this.modalService.warning('MESSAGE_DELETE_CONFIRMATION', Meevo.Components.Modal.ModalTranslationModes.Translate, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                    .then((res: boolean) => {
                        if (res) {
                            note.objectState = Meevo.Model.ObjectStateEnum.Deleted;
                            scope.dataService.customMethodData("api/PurchaseOrder/" + note.id + "/Note", "PUT", note).then((response) => {
                                //reload notes
                                scope.getNotes(scope.purchaseOrderId, Meevo.Model.ObjectStateEnum.Active);
                                //audit log
                                if (!scope.preventUsageTracking) {
                                    scope.usageTrackingLog(Meevo.Model.NounEnum.PurchaseOrderNotes, Model.VerbEnum.DeleteButtonClicked, null, scope.purchaseOrderId);
                                }
                            });
                        }
                    });
            }
        }

        checkForDeletedLineItems(): ng.IPromise<any> {
            var promises: ng.IPromise<any>[] = [];

            var foundProduct = false;
            for (var i = 0; i < this.backupPurchaseOrder.lineItems.length; i++) {
                foundProduct = false;
                for (var j = 0; j < this.purchaseOrder.lineItems.length; j++) {
                    if (this.purchaseOrder.lineItems[j].id == this.backupPurchaseOrder.lineItems[i].id
                        && this.purchaseOrder.lineItems[j].productInventoryType == this.backupPurchaseOrder.lineItems[i].productInventoryType) {
                        foundProduct = true;
                    }
                }
                if (!foundProduct && this.purchaseOrder.id != null) {
                    promises.push(this.dataService.customMethodData("api/PurchaseOrder/" + this.purchaseOrder.id + "/LineItems/" + this.backupPurchaseOrder.lineItems[i].id, "PUT", this.backupPurchaseOrder.lineItems[i]));
                }
            }

            return this.$q.all(promises);
        }


        savePurchaseOrder(keepEditing: boolean = false): ng.IPromise<any> {
            if (this.inSaveProcess) {
                return;
            }
            this.inSaveProcess = true;
            if (this.purchaseOrder != null && this.purchaseOrder.lineItems != null) {
                this.purchaseOrder.lineItems = _.filter(this.purchaseOrder.lineItems, function (item) { return item.orderQuantity > 0; });
            }
            this.hideReceivalSidebar();
            this.busyService.start();
            var httpMethod = this.purchaseOrder.id ? "PUT" : "POST";
            return this.dataService.customMethodData("api/PurchaseOrder", httpMethod, this.purchaseOrder).then((d) => {

                return this.selectPurchaseOrder(d.data.id).then(() => {

                    // if statement is used to make sure that we maintain a selection in the drop down list
                    if (d.data.distributorId == null) {
                        this.purchaseOrder.distributorId = null;
                    }
                    if (d.data.supplyCategoryEnum == null) {
                        this.purchaseOrder.supplyCategoryEnum = null;
                    }

                    for (var j = 0; j < this.purchaseOrder.lineItems.length; j++) {
                        if (this.purchaseOrder.lineItems[j].lineTotal == null) {
                            this.purchaseOrder.lineItems[j].lineTotal = 0;
                        }
                    }
                    //audit log 
                    if (this.mode == Meevo.Model.MaintenanceFormState.Editing) {
                        this.usageTrackingLog(Meevo.Model.NounEnum.PurchaseOrder, Model.VerbEnum.SaveButtonClicked, null, null);
                    }
                    if (!keepEditing) {
                        this.mode = MaintenanceFormState.Readonly;
                    }
                    this.isFirstSearch = true;
                    this.showResults = false;
                    this.showTheFilter();
                    this.isDirty = false;

                    this.isDistributorChanged = false;
                    this.backupLineItems = [];
                });
            }).catch((error) => {

            }).finally(() => {
                this.lockSort = false;
                this.busyService.stop();
                this.inSaveProcess = false;
            });
        }

        savePurchaseOrderAndReceival(keepEditing: boolean = false): ng.IPromise<any> {
            for (var i = 0; i < this.purchaseOrder.lineItems.length; i++) {
                for (var j = 0; j < this.poReceival.receivalLineItems.length; j++) {
                    if (this.poReceival.receivalLineItems[j].variantId.toString() == this.purchaseOrder.lineItems[i].id
                        && this.poReceival.receivalLineItems[j].productInventoryType == this.purchaseOrder.lineItems[i].productInventoryType
                        && this.poReceival.receivalLineItems[j].orderOfEntry == this.purchaseOrder.lineItems[i].orderOfEntry
                        && this.poReceival.receivalLineItems[j].orderQuantity != this.purchaseOrder.lineItems[i].orderQuantity) {
                        this.purchaseOrder.lineItems[i].orderQuantity = this.poReceival.receivalLineItems[j].orderQuantity;
                    }
                }
            }

            for (var j = 0; j < this.purchaseOrder.lineItems.length; j++) {
                if (this.purchaseOrder.lineItems[j].orderQuantity == 0) {
                    this.purchaseOrder.lineItems.splice(j, 1);
                }
            }

            this.hideReceivalSidebar();

            // Strip already-received (locked) lot allocations from the save payload.
            // Locked rows carry no _pending flag — they represent lots the DB already
            // has. Re-sending them alongside a new pending lot that collides on lot
            // number (same variant, same lotNumber) causes the backend to 500, since
            // the upsert returns one variantLot_TId for both and the save receives
            // two rows for the same lot. Pending-only filtering mirrors the intent:
            // this endpoint persists this-session changes; the locked rows are
            // already canonical in the DB. The in-memory poReceival keeps both so
            // the modal UI still renders the locked rows on re-open.
            var poReceivalForSave = angular.copy(this.poReceival) as any;
            if (poReceivalForSave && poReceivalForSave.receivalLineItems) {
                for (var li = 0; li < poReceivalForSave.receivalLineItems.length; li++) {
                    var line = poReceivalForSave.receivalLineItems[li];
                    if (line.lotAllocations && line.lotAllocations.length > 0) {
                        line.lotAllocations = line.lotAllocations.filter((a: ILotAllocation) => a && a._pending);
                    }
                }
            }

            var purchaseOrderAndReceival = {
                purchaseOrder: this.purchaseOrder,
                poReceival: poReceivalForSave
            }
            this.busyService.start();
            this.backupPoReceival = null;

            return this.dataService.customMethodData("api/PurchaseOrder/Receival", "POST", purchaseOrderAndReceival).then((d) => {
                if (this.mode == Meevo.Model.MaintenanceFormState.Editing) {
                    this.usageTrackingLog(Meevo.Model.NounEnum.PurchaseOrder, Model.VerbEnum.SaveButtonClicked, null, null);
                }

                if (!keepEditing) {
                    this.mode = MaintenanceFormState.Readonly;
                }

                if (!keepEditing) {
                    this.mode = MaintenanceFormState.Readonly;
                }

                this.showTheFilter();

                if (d.data.poReceival) {
                    this.poReceival = d.data.poReceival;
                }

                this.showReceival = true;
                this.isFirstSearch = false;
                this.showResults = false;
                this.isDirty = false;

                this.isDistributorChanged = false;
                this.backupLineItems = [];

                //get the PO to have the latest entityVersion bc the PoHeader_L updated when received
                return this.selectPurchaseOrder(d.data.purchaseOrder.id);
            }).catch((error) => {

            }).finally(() => {
                this.takeBackupPoReceival();
                this.lockSort = false;
                this.busyService.stop();
            });
        }

        saveNewPurchaseOrder(): ng.IPromise<any> {
            if (this.inSaveProcess)
                return;
            this.inSaveProcess = true;
            if (this.purchaseOrder != null && this.purchaseOrder.lineItems != null)
                this.purchaseOrder.lineItems = _.filter(this.purchaseOrder.lineItems, function (item) { return item.orderQuantity > 0; });

            this.purchaseOrder.autoGeneratePONumber = true;
            this.busyService.start();
            return this.dataService.customMethodData("api/PurchaseOrder", "POST", this.purchaseOrder).then((d) => {
                this.purchaseOrder.id = d.data.id;

                // if statement is used to make sure that we maintain a selection in the drop down list
                if (d.data.distributorId == null)
                    this.purchaseOrder.distributorId = null;
                if (d.data.supplyCategoryEnum == null)
                    this.purchaseOrder.supplyCategoryEnum = null;

                this.backupPurchaseOrder = angular.copy(this.purchaseOrder);
                this.searchForPurchaseOrders(PurchaseOrderStateEnum.NotReceived);

                //audit log
                if (this.mode == Meevo.Model.MaintenanceFormState.Adding) {
                    this.usageTrackingLog(Meevo.Model.NounEnum.PurchaseOrder, Model.VerbEnum.SaveButtonClicked, null, null);
                }
                this.mode = MaintenanceFormState.Readonly;
                this.isFirstSearch = true;
                this.showResults = false;
                this.showTheFilter();
                this.hideReceivalSidebar();

                return this.selectPurchaseOrder(this.purchaseOrder.id);
            }).catch((error) => {

            }).finally(() => {
                this.lockSort = false;
                this.busyService.stop();
                this.inSaveProcess = false;
            });
        }

        submitSalonInteractivePurchaseOrder(poId: Guid): void {
            if (poId != null && this.purchaseOrder.id == poId) {
                if (this.purchaseOrder.distributorReferenceNumber) {
                    this.modalService.alert('MESSAGE_DISTRIBUTOR_REF_PO_SALON_INTERACTIVE', Meevo.Components.Modal.ModalTranslationModes.Translate);
                    return;
                }
                this.modalService.alert("LABEL_PO_SALON_INTERACTIVE_CONFIRM", Meevo.Components.Modal.ModalTranslationModes.Translate, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                    .then((res: boolean) => {
                        if (res) {
                            if (this.inSaveProcess)
                                return;
                            this.inSaveProcess = true;
                            this.busyService.start();
                            var externalPo = {
                                id: poId,
                                note: this.$translate.instant("MESSAGE_PO_SALON_INTERACTIVE_NOTE"),
                                externalInventoryApp: ExternalInventoryAppEnum.SalonInteractive
                            };
                            // get SalonInteractive settings
                            this.dataService.customMethodData(`api/SalonInteractiveOrder`, "GET", null)
                                .then((response) => {
                                    var salonInteractiveSettings: Meevo.Model.SalonInteractive = response.data;
                                    return this.submitSalonInteractivePurchaseOrderWorker(poId, externalPo, salonInteractiveSettings);
                                });
                        }
                    });
            }
        }

        submitSalonInteractivePurchaseOrderWorker(poId: Guid, externalPo: any, salonInteractiveSettings: Meevo.Model.SalonInteractive): ng.IPromise<any> {
            return this.dataService.customMethodData(`/api/PurchaseOrder/${poId}/SendToExternal`, "POST", externalPo)
                .then((response) => {
                    if (response) {
                        let data: Meevo.Model.PurchaseOrderSubmissionResponse = response.data;
                        if (data.statusCode == 0) {  // success
                            this.purchaseOrder = data.purchaseOrder;
                            if (this.purchaseOrder.externalCartUrl) {
                                this.modalService.alert(this.$translate.instant("MESSAGE_PO_SALON_INTERACTIVE_SUBMISSION_CART_TRANSFER", {
                                    salonInteractivePoNumber: this.purchaseOrder.distributorReferenceNumber,
                                    poNumber: this.purchaseOrder.purchaseOrderNumber
                                })).then(() => {
                                    window.open(
                                        this.purchaseOrder.externalCartUrl,
                                        "_blank",
                                        "noopener,noreferrer");
                                });
                            }
                            else {
                                this.modalService.alert(this.$translate.instant("MESSAGE_PO_SALON_INTERACTIVE_SUBMISSION", { salonInteractivePoNumber: this.purchaseOrder.distributorReferenceNumber, poNumber: this.purchaseOrder.purchaseOrderNumber }));
                            }
                        }
                        else {  // failure
                            this.busyService.stop();
                            if (data.statusCode == 1) { // failure to acquire new access token
                                if (this.$rootScope.popupsalonInteractiveLoginWindow && !this.$rootScope.popupsalonInteractiveLoginWindow.closed) {
                                    this.$rootScope.popupsalonInteractiveLoginWindow.focus();
                                    return;
                                }
                                const params = { inventoryApp: 11045824/*salonInteractive*/ };
                                return this.dataService.customMethodData(`api/ExternalOrder/Authorize/State`, 'GET', null, params)
                                    .then((response) => {
                                        this.$rootScope.popupsalonInteractiveLoginWindow = window.open(salonInteractiveSettings.authorizeUrl + response.data.state.toString(), "_blank", "width=500,height=500", false);
                                    });
                            }
                            else {
                                this.modalService.alert(data.statusMessage, Meevo.Components.Modal.ModalTranslationModes.Translate);
                            }
                        }
                    }
                }).catch((error) => {
                    //this.modalService.alert('MESSAGE_PO_SUBMISSION_FAILURE', Meevo.Components.Modal.ModalTranslationModes.Translate);
                }).finally(() => {
                    this.busyService.stop();
                    this.inSaveProcess = false;
                });
        }



        /**
          * 
          *               Aveda empowered order
          * ***************************************************************
         **/
        submitAvedaPurchaseOrder(poId: Guid): void {
            if (poId != null && this.purchaseOrder.id == poId) {
                if (this.purchaseOrder.distributorReferenceNumber) {
                    this.modalService.alert('MESSAGE_DISTRIBUTOR_REF_PO', Meevo.Components.Modal.ModalTranslationModes.Translate);
                    return;
                }
                this.modalService.alert("LABEL_EMPOWERING_ORDER_CONFIRM", Meevo.Components.Modal.ModalTranslationModes.Translate, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                    .then((res: boolean) => {
                        if (res) {
                            if (this.inSaveProcess)
                                return;
                            this.inSaveProcess = true;
                            this.busyService.start();
                            var externalPo = {
                                id: poId,
                                note: this.$translate.instant("MESSAGE_AVEDA_PO_NOTE"),
                                externalInventoryApp: ExternalInventoryAppEnum.Aveda
                            };
                            // get Aveda settings
                            this.dataService.customMethodData(`/api/ExternalOrder`, "GET", null)
                                .then((response) => {
                                    var avedaSettings: Meevo.Model.Aveda = response.data;
                                    // if (avedaSettings.version == Meevo.Model.AvedaVersionEnum.AvedaVersion1) {
                                    //     return this.submitAvedaPurchaseOrderWorkerOld(poId, externalPo);
                                    // }
                                    // else {
                                    //     // Aveda Version 2
                                    //     if (!avedaSettings.hasValidToken) {
                                    //         this.busyService.stop();
                                    //         if (this.$rootScope.popupAvedaLoginWindow && !this.$rootScope.popupAvedaLoginWindow.closed) {
                                    //             this.$rootScope.popupAvedaLoginWindow.focus();
                                    //             return;
                                    //         }
                                    //         return this.dataService.customMethodData(`api/ExternalOrder/Authorize/State`, 'GET', null)
                                    //             .then((response) => {
                                    //                 this.$rootScope.popupAvedaLoginWindow = window.open(avedaSettings.authorizeUrl + response.data.state.toString(), "_blank", "width=500,height=500", false);
                                    //             });
                                    //     }
                                    //     else {
                                    //         return this.submitAvedaPurchaseOrderWorkerOld(poId, externalPo);
                                    //     }
                                    // }
                                    return this.submitAvedaPurchaseOrderWorker(poId, externalPo, avedaSettings);
                                });
                        }
                    });
            }
        }

        submitAvedaPurchaseOrderWorkerOld(poId: Guid, externalPo: any): ng.IPromise<any> {
            return this.dataService.customMethodData(`/api/PurchaseOrder/${poId}/SendToExternal`, "POST", externalPo)
                .then((response) => {
                    if (response) {
                        this.purchaseOrder = response.data;
                        var successfulLineItems = _.filter(this.purchaseOrder.lineItems, function (item) { return item.purchaseOrderLineItemResponseCode === PurchaseOrderLineItemResponseCodeEnum.Succeeded; });
                        if (successfulLineItems.length === this.purchaseOrder.lineItems.length) {
                            this.modalService.message(this.$translate.instant("MESSAGE_PO_SUBMISSION_SUCCESS", { avedaPoNumber: response.data["distributorReferenceNumber"], poNumber: this.purchaseOrder.purchaseOrderNumber }));
                        }
                        else {
                            this.modalService.alert(this.$translate.instant("MESSAGE_PO_SUBMISSION_PARTIAL_SUCCESS", { avedaPoNumber: response.data["distributorReferenceNumber"], poNumber: this.purchaseOrder.purchaseOrderNumber }));
                        }
                    }
                }).catch((error) => {
                    //this.modalService.alert('MESSAGE_PO_SUBMISSION_FAILURE', Meevo.Components.Modal.ModalTranslationModes.Translate);
                }).finally(() => {
                    this.busyService.stop();
                    this.inSaveProcess = false;
                });
        }

        submitAvedaPurchaseOrderWorker(poId: Guid, externalPo: any, avedaSettings: Meevo.Model.Aveda): ng.IPromise<any> {
            return this.dataService.customMethodData(`/api/PurchaseOrder/${poId}/SendToExternal`, "POST", externalPo)
                .then((response) => {
                    if (response) {
                        let data: Meevo.Model.PurchaseOrderSubmissionResponse = response.data;
                        if (data.statusCode == 0) {  // success
                            this.purchaseOrder = data.purchaseOrder;
                            var successfulLineItems = _.filter(this.purchaseOrder.lineItems, function (item) { return item.purchaseOrderLineItemResponseCode === PurchaseOrderLineItemResponseCodeEnum.Succeeded; });
                            if (successfulLineItems.length === this.purchaseOrder.lineItems.length) {
                                this.modalService.message(this.$translate.instant("MESSAGE_PO_SUBMISSION_SUCCESS", { avedaPoNumber: this.purchaseOrder.distributorReferenceNumber, poNumber: this.purchaseOrder.purchaseOrderNumber }));
                            }
                            else {
                                this.modalService.alert(this.$translate.instant("MESSAGE_PO_SUBMISSION_PARTIAL_SUCCESS", { avedaPoNumber: this.purchaseOrder.distributorReferenceNumber, poNumber: this.purchaseOrder.purchaseOrderNumber }));
                            }
                        }
                        else {  // failure
                            this.busyService.stop();
                            if (data.statusCode == 1) { // failure to acquire new access token
                                if (this.$rootScope.popupAvedaLoginWindow && !this.$rootScope.popupAvedaLoginWindow.closed) {
                                    this.$rootScope.popupAvedaLoginWindow.focus();
                                    return;
                                }
                                const params = { inventoryApp: 11045761/*aveda*/ };
                                return this.dataService.customMethodData(`api/ExternalOrder/Authorize/State`, 'GET', null, params)
                                    .then((response) => {
                                        this.$rootScope.popupAvedaLoginWindow = window.open(avedaSettings.authorizeUrl + response.data.state.toString(), "_blank", "width=500,height=500", false);
                                    });
                            }
                        }
                    }
                }).catch((error) => {
                    //this.modalService.alert('MESSAGE_PO_SUBMISSION_FAILURE', Meevo.Components.Modal.ModalTranslationModes.Translate);
                }).finally(() => {
                    this.busyService.stop();
                    this.inSaveProcess = false;
                });

        }




        displayErrorSubmission(status: string, message: string) {

            let statusMessage = this.$translate.instant('TOOLTIP_LINEITEM_STATUS_' + status);
            let fullMessage: string;

            fullMessage = this.purchaseOrder.isAvedaOrderingEnabled
                ? (message ? statusMessage += "<br/><br/>" + message : statusMessage)
                : message;

            this.modalService.message(fullMessage);
        }

        //submit po to aveda
        isAvedaDistributor(): boolean {
            if (this.purchaseOrder != null && this.purchaseOrder.lineItems != null && this.purchaseOrder.lineItems.length > 0) {
                this.purchaseOrder.lineItems.forEach(i => {
                    if (!i.isAvedaOrderingEnabled)
                        return false;
                });
                return true;
            }

            return false;
        }

        isAvedaAccountActive() {
            // check for Aveda module before calling this
            if (this.securityChecker.checkCachedSecurityKey(this.securityKeys.INTEGRATION_AVEDA_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ) == 2056
                || this.securityChecker.checkCachedSecurityKey(this.securityKeys.INVENTORY_PURCHASEORDER_SUBMITPO_ACTION) == 2056) {
                this.dataService.customMethodData("api/ExternalOrder/", "GET", null).then((d) => {
                    this.isAvedaAccountObjectStateActive = d.data["objectState"] == Model.ObjectStateEnum.Active;
                });
            }
        }

        showErrorIcon(item: PurchaseOrderDetails) {
            if (!this.purchaseOrder || !item) return false;
            return (this.purchaseOrder.isAvedaOrderingEnabled || this.purchaseOrder.salonInteractiveDistributorId != null)
                && item.purchaseOrderLineItemResponseCode > 0
                && item.purchaseOrderLineItemResponseCode != PurchaseOrderLineItemResponseCodeEnum.Succeeded;
        }


        // parameter is used for Desktop Verison
        updateProductAndUpdateOrder(prod?: any, forceAdd?: boolean): void {

            //Desktop Version calulate the originalActualCount because this is no longer handled by the function qtyUpdateModal()'s
            //(found in the Inventory Count Controller) modal resolve function 
            if (prod != null) {
                this.product = prod;
            }

            this.originalActualCount = 0; // reset this value for every call

            if (this.purchaseOrder != null && this.purchaseOrder.lineItems != null) {
                for (var i = 0; i < this.purchaseOrder.lineItems.length; i++) {
                    if (this.purchaseOrder.lineItems[i].productInventoryType == this.product.productInventoryType
                        && ((this.purchaseOrder.lineItems[i].orderOfEntry == this.product.orderOfEntry
                            && this.product.orderOfEntry != 0)
                            || (this.purchaseOrder.lineItems[i].dateAdded == this.product.dateAdded
                                && this.purchaseOrder.lineItems[i].orderOfEntry == 0
                                && this.product.orderOfEntry == 0))
                        && (this.purchaseOrder.lineItems[i].id == this.product.id
                            || this.purchaseOrder.lineItems[i].variantId == this.product.id
                            || (this.purchaseOrder.lineItems[i].variantId != null
                                && this.product.variantId != null
                                && this.purchaseOrder.lineItems[i].variantId == this.product.variantId))) {
                        this.originalActualCount = this.purchaseOrder.lineItems[i].orderQuantity;
                    }
                }
            }

            this.lineItems = {
                id: this.product.id,
                displayName: this.product.displayName,
                variantDisplayName: this.product.variantDisplayName,
                orderQuantity: this.product.orderQuantity,
                variantId: this.product.id,
                onHand: this.product.onHand,
                suggestedQty: this.product.suggestedQty,
                wholeSale: this.product.wholeSale,
                unitPrice: this.product.unitPrice,
                lineTotal: this.calculateLineTotal(this.product),
                attributes: this.product.variantAttributes,
                willSave: this.product.willSave,
                productPackageType: this.product.productPackageType,
                multiplesOf: this.product.multiplesOf,
                productId: this.product.productId,
                orderPoint: this.product.orderPoint,
                modelQuantity: this.product.modelQuantity,
                sku: this.product.sku,
                barCode: this.product.barCode,
                productInventoryType: this.product.productInventoryType,
                variantDistributorDisplayName: this.product.variantDistributorDisplayName,
                isAvedaOrderingEnabled: this.product.isAvedaOrderingEnabled
            };

            // if statement and for loop below determine wether or not to add a new product or update an existing one
            var addNewProduct = true;
            if (this.purchaseOrder.lineItems != null) {
                for (var i = 0; i < this.purchaseOrder.lineItems.length; i++) {
                    if ((this.purchaseOrder.lineItems[i].productInventoryType == this.product.productInventoryType)
                        && (this.purchaseOrder.lineItems[i].id == this.product.id
                            || this.purchaseOrder.lineItems[i].variantId == this.product.id)) {

                        this.purchaseOrder.lineItems[i].orderQuantity = this.product.orderQuantity;
                        this.purchaseOrder.lineItems[i].lineTotal = this.calculateLineTotal(this.product);

                        addNewProduct = false;//found existing product within the Count details
                        i = 99999;
                        break;
                    }
                }
            }

            if (addNewProduct && (this.product.orderQuantity > 0 || forceAdd)) {
                if (this.purchaseOrder.lineItems == null)
                    this.purchaseOrder.lineItems = [];

                this.purchaseOrder.lineItems.push(this.lineItems);
                this.purchaseOrder.itemCount++;
                this.purchaseOrder.itemTotal += this.product.orderQuantity;
            }
            else {
                this.purchaseOrder.itemTotal += (this.product.orderQuantity - this.originalActualCount);
            }

            // if the product is null then save to DB because this is the behavior for the mobile version auto save mode
            if (prod == null)
                this.savePurchaseOrder();
        }

        addOrRemoveMultipleProductsFromOrder(index: number, products: any, context: any): void {
            if (products) { // make sure products are not null
                for (var i = 0; i < products.length; i++) {
                    var foundMatch = false;

                    if (context.purchaseOrder.lineItems != null) {
                        for (var j = 0; j < context.purchaseOrder.lineItems.length; j++) {
                            if (context.purchaseOrder.lineItems[j].id == products[i].id
                                && context.purchaseOrder.lineItems[j].productInventoryType == products[i].productInventoryType) {
                                products[i].willSave = true;
                                products[i].orderQuantity = context.purchaseOrder.lineItems[j].orderQuantity;
                                products[i].lineTotal = this.calculateLineTotal(products[i]);
                                foundMatch = true;
                                break;
                            }
                        }
                    }
                }
                for (var i = 0; i < products.length; i++) {
                    var prod = products[i];
                    if (prod.willSave) {
                        this["context"].updateProductAndUpdateOrder(prod);
                    } else {
                        this["context"].removeProductFromCount(prod);
                    }
                }
            }

        }

        addOrRemoveProductFromOrder(prod: any): void {
            this.isDirty = true;
            if (prod.willSave) {
                this.updateProductAndUpdateOrder(prod);
            } else {
                this.removeProductFromCount(prod);
            }
        }

        removeProductFromCount(prod: any): void {
            this.isDirty = true;
            if (this.purchaseOrder.lineItems != null && this.purchaseOrder.lineItems.length > 0) {
                for (var i = 0; i < this.purchaseOrder.lineItems.length; i++) {

                    if ((this.purchaseOrder.lineItems[i].productInventoryType == prod.productInventoryType)
                        && ((this.purchaseOrder.lineItems[i].orderOfEntry == prod.orderOfEntry
                            && prod.orderOfEntry != 0)
                            || (this.purchaseOrder.lineItems[i].dateAdded == prod.dateAdded
                                && this.purchaseOrder.lineItems[i].orderOfEntry == 0
                                && prod.orderOfEntry == 0))
                        && (this.purchaseOrder.lineItems[i].id == prod.id
                            || this.purchaseOrder.lineItems[i].variantId == prod.id
                            || (this.purchaseOrder.lineItems[i].variantId != null
                                && prod.variantId != null
                                && this.purchaseOrder.lineItems[i].variantId == prod.variantId))) {

                        this.purchaseOrder.itemCount--;
                        this.purchaseOrder.itemTotal -= prod.orderQuantity;
                        this.purchaseOrder.lineItems.splice(i, 1);
                        break;
                    }
                }
            }
        }

        isPurchaseOrderDetailEmpty(): boolean {
            if (this.purchaseOrder != null &&
                this.purchaseOrder.lineItems != null &&
                this.purchaseOrder.lineItems.length > 0)
                return false;
            else
                return true;
        }

        deletePurchaseOrder(poId: Guid): ng.IPromise<any> {
            let deleteMessage = this.$translate.instant("MESSAGE_PO_DELETE");
            if (this.purchaseOrder.dateSubmitted && this.purchaseOrder.id) {
                if (this.purchaseOrder.isAvedaOrderingEnabled) {
                    deleteMessage = this.$translate.instant("MESSAGE_PO_DELETE_SUBMITTED_TOAVEDA");
                }
                else if (this.purchaseOrder.salonInteractiveDistributorId) {
                    deleteMessage = this.$translate.instant("MESSAGE_PO_DELETE_SUBMITTED_TO_SALON_INTERACTIVE");
                }
            }
            return this.modalService.warning(deleteMessage, 0, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                .then((data) => {
                    this.purchaseOrder.objectState = Meevo.Model.ObjectStateEnum.Deleted;
                    if (this.purchaseOrder.purchaseOrderState == PurchaseOrderStateEnum.NotReceived) {
                        if (this.inSaveProcess)
                            return;
                        this.inSaveProcess = true;
                        this.busyService.start();
                        return this.dataService.customMethodData("api/PurchaseOrder/" + poId, "Patch", this.purchaseOrder).then((d) => {
                            //audit log
                            if (this.mode == Meevo.Model.MaintenanceFormState.Editing) {
                                this.usageTrackingLog(Meevo.Model.NounEnum.PurchaseOrder, Model.VerbEnum.DeleteButtonClicked, null, null);

                                this.mode = MaintenanceFormState.Readonly;
                                this.isFirstSearch = true;
                                this.showResults = false;
                            }
                            this.$timeout(() => {
                                $("#purchaseOrderSearch").click();
                            }, 1);
                        }).catch((error) => {
                            return false;;
                        }).finally(() => {
                            this.busyService.stop();
                            this.inSaveProcess = false;
                            return true;
                        });
                    }
                    else {
                        return this.modalService.alert("You cant delete PO, it is already received");
                    }
                });
        }

        isPoStateNotReceived(): boolean {
            if (this.purchaseOrder != null && this.purchaseOrder.purchaseOrderState == PurchaseOrderStateEnum.NotReceived) {
                return true;
            }
            else {
                return false;
            }
        }

        sumTotalItems(): number {
            var sum = 0;
            if (this.products != null) {
                for (var i = 0; i < this.products.length; i++) {
                    sum += this.products[i].actualCount;
                }
            }
            return sum;
        }

        setProduct(prod: any) {
            if (prod.onHand != null)
                this.product = prod;
            else
                this.product = prod.productVariant;
        }


        removePurchaseOrderLineItems(): void {
            this.purchaseOrder.lineItems = [];
        }

        automaticOrder(excludeItemsAlreadyOnOrder: boolean = false): ng.IPromise<any> {
            // Make API Call and return all records with the values of the Order Quantity set to the suggested value
            var scope = this;

            scope.confirmationMessage = "Count Deleted!";
            return scope.modalService.confirm("MESSAGE_AUTOMATIC_ORDER_CONFIRMATION", Meevo.Components.Modal.ModalTranslationModes.Translate).then((data) => {
                var isCriteriaMatch: boolean = false;
                scope.purchaseOrder.lineItems.forEach((item, ndx, arr) => {
                    if (item.onHand <= item.orderPoint && item.suggestedQty > 0) {
                        item.orderQuantity = item.suggestedQty;
                        item.lineTotal = scope.calculateLineTotal(item);
                        if ((item.orderOfEntry == null || item.orderOfEntry == 0) && item.dateAdded == null) {
                            item.dateAdded = this.dateLoadProducts;
                        }
                        isCriteriaMatch = true;
                    }
                });
                if (!isCriteriaMatch) {
                    return scope.modalService.alert("No products have met the criteria to be ordered at this moment. (No change has been made to this purchase order)", null);
                }
                scope.calculateTotals();
            });
        }



        isNullOrEmpty(object: any): boolean {
            if (object)
                return true;
            else
                return false;
        }

        returnConcatinatedName(item: any): string {
            if (item.displayName != null && item.displayName.length != null && item.displayName.length > 0) {
                var concatdisplayName = "";
                for (var i = 0; i < item.displayName.length; i++) {
                    if (i + 1 < item.displayName.length)
                        concatdisplayName += item.displayName[i] + " / ";
                    else {
                        concatdisplayName += item.displayName[i];
                    }
                }
                return " - " + concatdisplayName;
            }
            return "";
        }

        returnAttributeConcatinatedName(attributes: any): string {
            if (attributes != null && attributes.length != null && attributes.length > 0) {
                var concatdisplayName = "";
                for (var i = 0; i < attributes.length; i++) {
                    for (var j = 0; j < attributes[i].displayName.length; j++) {
                        if (j + 1 < attributes[i].displayName.length || i + 1 < attributes.length)
                            concatdisplayName += attributes[i].displayName[j] + " / ";
                        else {
                            concatdisplayName += attributes[i].displayName[j];
                        }
                    }
                }
                return " - " + concatdisplayName;
            }
            return "";
        }

        /**
         * create new purchase order note
         * @param note
         */
        noteGetGeneral(purchaseOrderId: any, poObjectState: any, pageOrigin: number, isUnSavedPo?: boolean) {
            if (isUnSavedPo && this.isEditing()) {
                this.modalService.confirmHandler(`MESSAGE_PURCHASEORDER_EDIT_CONFIRMATION`, 0).then((d) => {
                    if (d) {
                        return this.savePurchaseOrder().then(() => {
                            this.viewNotes = true;
                            this.mode = MaintenanceFormState.Readonly;
                            this.pageNoteOrigin(pageOrigin);
                            this.getNotes(purchaseOrderId, poObjectState);
                        });
                    }
                    else {
                        return;
                    }
                });
            }
            else if (!this.isEditing()) {
                this.pageNoteOrigin(pageOrigin);
                this.getNotes(purchaseOrderId, poObjectState);
            }
        }
        /**
         * Get list of notes 
         * @param purchaseOrderId
         */
        getNotes(purchaseOrderId: any, poObjectState: any) {

            console.log("getNotes start ...");

            if (purchaseOrderId == null || purchaseOrderId === "") {
                console.log("Purchase order empty.");
                return;
            }

            if (this.purchaseOrderNote != null || this.purchaseOrderNote != undefined) {
                // sets purchase order  id when page loads
                this.purchaseOrderNote.purchaseOrderId = purchaseOrderId;
                this.purchaseOrderId = purchaseOrderId;
                this.purchaseOrderNote.poObjectState = poObjectState;
            }
            let criteria = {
                purchaseOrderId: purchaseOrderId,
                objectState: Meevo.Model.ObjectStateEnum.Active
            }

            let request = {
                pageNumber: 0,
                itemsPerPage: 10,
                criteria: criteria,
                sortBy: 'DateCreated',
                sortDirection: Model.SortDirection.Descending,
                includeActive: true,
                includeDeleted: false,
                includeInactive: false
            }
            var url = "PurchaseOrder/" + purchaseOrderId + "/Note";
            this.infiteitems = new Meevo.Components.BaseClasses.PagedResults(this.dataService, url);
            this.infiteitems.clearSearch();
            this.infiteitems.initSearch(request);
        }


        /*
        *    SECURITY KEYS
        */
        protected buildCrudSecurityKeys(baseKey, hasCreateKey = false, hasCopyKey = false, hasChangeAccessKey = false, hasChangeOwnerKey = false) {
            this.addSecurityKey = baseKey + ((hasCreateKey) ? Meevo.Components.Common.SecurityParts.KEY_PART_CREATE : Meevo.Components.Common.SecurityParts.KEY_PART_WRITE);
            this.editSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
            this.deleteSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE;
            this.editRecivalSecurityKey = this.securityKeys.INVENTORY_PURCHASEORDERRECEIVAL + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
            this.submitSecurityKey = this.securityKeys.INVENTORY_PURCHASEORDER_SUBMITPO_ACTION;
            this.discountSecurityKey = this.securityKeys.INVENTORY_PURCHASEORDER_DISCOUNTS_ACTION;
        }

        /*
        *   TRACKING 
        */
        usageTrackingLog(nounEnum, verbEnum, payload, mainEntityId): void {
            if (nounEnum !== null) {
                var trackingItem = new Meevo.Model.TrackingItem(nounEnum, verbEnum, payload, mainEntityId);
                this.trackingService.saveTrackingInfo(trackingItem);
            }
        }

        selectReceivalsFromSearch = (item, e) => {
            if (e) {
                e.stopPropagation();
            }
            this.mode = MaintenanceFormState.Readonly;
            this.showReceival = true;
            this.viewNotes = false;
            this.pageRecievalOrigin(1);
            return this.selectPurchaseOrder(item.id).then(() => {
                return this.selectPoReceivals(item.id);
            });
        }

        /*
                        Receivals
        *******************************************************************  */
        poReceivalSelectGeneral(poId: any, pageOrigin: number, isUnSavedPo?: boolean): ng.IPromise<any> {
            if (this.isEditing() && isUnSavedPo) {
                return this.modalService.confirmHandler(`MESSAGE_PURCHASEORDER_EDIT_CONFIRMATION`, 0).then((d) => {
                    if (d) {
                        return this.savePurchaseOrder().then(() => {
                            this.showReceival = true;
                            this.pageRecievalOrigin(pageOrigin);
                        });
                    }
                    else {
                        return;
                    }
                });
            }
            else {
                this.viewNotes = false;
                this.showReceival = true;
                this.pageRecievalOrigin(pageOrigin);
                return this.selectPoReceivals(poId);
            }
        }

        selectPoReceivals(poId: any): ng.IPromise<any> {
            //this.viewNotes = false;

            this.backupPoReceival = null;

            var receival = {
                Id: null,
                purchaseOrderId: poId,
                summarizeHeader: true
            };
            return this.dataService.customMethodData("api/PurchaseOrder/" + poId + "/ReceivalGet", "POST", receival)
                .then((d) => {
                    this.poReceival = d.data;
                    if (d.data.distributorId == null) {
                        this.poReceival.distributorId = null;
                    }
                    return this.getPoReceivalLineItems(poId);

                })
                .finally(() => {
                    this.takeBackupPoReceival();
                });
        }

        getSortOption(sortOption) {
            return (sortOption)
                + ((sortOption == 'ProductCategory') ? ',ProductSubCategory' : '')
                + ((sortOption != 'VariantSku' && sortOption != 'SKU') ? ',VariantSku' : '');
        }
        getPoReceivalLineItems(poId: any) {
            let criteria = {
                purchaseOrderId: poId,
                poReceivableId: null,
                summarizeLineItem: true
            }
            let request = {
                pageNumber: 0,
                itemsPerPage: 10000, // need to get all, not just 10,000 in case there are more
                criteria: criteria,
                sortBy: this.getSortOption((this.poReceival.sortOption || this.purchaseOrder.sortOption))
            }
            return this.dataService.customMethodData("api/PurchaseOrder/" + poId + "/ReceivalLineItem/List", "POST", request)
                .then((response) => {
                    if (!response || !this.poReceival) return;
                    this.poReceival.receivalLineItems = response.data;
                    this.poReceival.receivalLineItems.forEach((receivalLineItem) => {
                        if (receivalLineItem.receiveQuantity > 0) {
                            var quantity: number = receivalLineItem.receiveQuantity;
                            if (receivalLineItem.multiplesOf && receivalLineItem.productPackageType === Meevo.Model.ProductPackageTypeEnum.Case) {
                                quantity = this.roundingService.multiplyNormalizedNumbers(receivalLineItem.multiplesOf, receivalLineItem.receiveQuantity);
                            }
                            var unitPrice = receivalLineItem.receivableLineTotal / quantity;
                            this.updatePurchaseOrderUnitPriceFromReceival(receivalLineItem.variantId, receivalLineItem.productInventoryType, receivalLineItem.orderOfEntry, unitPrice);
                        }
                    });
                });
        }

        updatePurchaseOrderUnitPriceFromReceival(variantId, productInventoryType, orderOfEntry, unitPrice) {
            if (this.purchaseOrder.lineItems) {
                var poLineItem = _.findWhere(this.purchaseOrder.lineItems, { id: variantId, productInventoryType: productInventoryType, orderOfEntry: orderOfEntry });
                if (poLineItem) {
                    poLineItem.unitPrice = unitPrice;
                    var quantity: number = poLineItem.orderQuantity;
                    if (poLineItem.multiplesOf && poLineItem.productPackageType === Meevo.Model.ProductPackageTypeEnum.Case) {
                        quantity = this.roundingService.multiplyNormalizedNumbers(poLineItem.multiplesOf, poLineItem.orderQuantity);
                    }
                    poLineItem.lineTotal = this.roundingService.normalizeDecimalPlaces(unitPrice * quantity);
                    //poLineItem.lineTotal = this.calculateLineTotalWithValues(poLineItem.orderQuantity, unitPrice, poLineItem.multiplesOf, poLineItem.productPackageType);
                }
            }
        }

        filterProducts(product: string): ng.IPromise<any> {
            let criteria = {
                purchaseOrderId: this.poReceival.purchaseOrderId,
                poReceivableId: null,
                summarizeLineItem: true,
                filter: product
            }
            let request = {
                pageNumber: 0,
                itemsPerPage: 10000,
                criteria: criteria,
                sortBy: this.getSortOption((this.poReceival.sortOption || this.purchaseOrder.sortOption))
            }
            return this.dataService.customMethodData("api/PurchaseOrder/" + this.poReceival.purchaseOrderId + "/ReceivalLineItem/List", "POST", request)
                .then((response) => {
                    this.poReceival.receivalLineItems = response.data;
                });
        }
        noteGetReceivable(purchaseOrderId: any, poObjectState: any, pageOrigin: number, isUnSavedPo?: boolean) {
            if (isUnSavedPo && this.isEditing()) {
                this.modalService.confirmHandler(`MESSAGE_PURCHASEORDER_EDIT_CONFIRMATION`, 0).then((d) => {
                    if (d) {
                        this.savePoReceivals().then(() => {
                            this.mode = MaintenanceFormState.Readonly;
                            this.pageNoteOrigin(pageOrigin);
                            this.showReceival = false;
                            this.getNotes(purchaseOrderId, poObjectState);
                        });
                    }
                    else {
                        return;
                    }
                });
            }
            else if (!this.isEditing()) {
                this.pageNoteOrigin(pageOrigin);
                this.showReceival = false;
                this.getNotes(purchaseOrderId, poObjectState);
            }
        }
        savePoReceivals(keepEditing: boolean = false): ng.IPromise<any> {
            if (this.poReceival == null || this.inSaveProcess || !this.isValidatePoReceival()) {
                return;
            }
            this.hideReceivalSidebar();

            this.inSaveProcess = true;
            return this.savePurchaseOrderAndReceival(keepEditing).finally(() => { this.inSaveProcess = false; });
            //this.$mdSidenav('receivalSidenav').close();
        }

        updateReceivalQuantity(item: PoReceivalLineItem) {
            if (this.poReceival != null || this.poReceival != undefined) {
                if (this.poReceival.receivalLineItems == null || this.poReceival.receivalLineItems == undefined) {
                    this.poReceival.receivalLineItems = [];
                    this.poReceival.receivalLineItems.push(item);
                    this.poReceival.receivalLineItems[0].receivableLineTotal = this.calculateReceivableLineTotal(this.poReceival.receivalLineItems[0], false);
                }
                else {
                    var isVariantAvailable = 0;
                    for (var i = 0; i < this.poReceival.receivalLineItems.length; i++) {
                        if (this.poReceival.receivalLineItems[i].variantId == item.variantId
                            && this.poReceival.receivalLineItems[i].productInventoryType == item.productInventoryType
                            && this.poReceival.receivalLineItems[i].orderOfEntry == item.orderOfEntry) {
                            this.poReceival.receivalLineItems[i].receiveQuantity = item.receiveQuantity;
                            this.poReceival.receivalLineItems[i].receivableLineTotal = this.calculateReceivableLineTotal(this.poReceival.receivalLineItems[i], true);
                            isVariantAvailable++;
                        }
                    }
                    if (isVariantAvailable == 0)
                        this.poReceival.receivalLineItems.push(item);
                }
            }
        }

        receiveAll(): any {
            if (this.poReceival != null || this.poReceival != undefined) {
                if (this.poReceival.receivalLineItems == null || this.poReceival.receivalLineItems == undefined) {
                    this.poReceival.receivalLineItems = [];

                } else {
                    for (var i = 0; i < this.poReceival.receivalLineItems.length; i++) {
                        if (this.poReceival.receivalLineItems[i].trackLots) continue; // Skip lot-tracked items — they require the modal
                        if (this.poReceival.receivalLineItems[i].receiveQuantity >= this.poReceival.receivalLineItems[i].orderQuantity) {
                            this.poReceival.receivalLineItems[i].currentReceiveQuantity = 0;
                        }
                        else {
                            this.poReceival.receivalLineItems[i].currentReceiveQuantity = this.poReceival.receivalLineItems[i].orderQuantity - this.poReceival.receivalLineItems[i].receiveQuantity;
                        }
                        this.poReceival.receivalLineItems[i].receivableLineTotal = this.calculateReceivableLineTotal(this.poReceival.receivalLineItems[i], true);
                        this.isDirty = true;
                    }
                }
            }
        }

        showReceivalLineTotalErrorMessage(item: any) {
            if (this.backupPoReceival != null && this.backupPoReceival.receivalLineItems != null && this.backupPoReceival.purchaseOrderState == this.PurchaseOrderStateEnum.PartiallyReceived) {
                let backupItem = this.backupPoReceival.receivalLineItems.find(li => li.variantId == item.variantId && li.productInventoryType == item.productInventoryType && li.orderOfEntry == item.orderOfEntry);
                if (backupItem != null && item.currentReceiveQuantity > 0 && item.receivableLineTotal < backupItem.receivableLineTotal) {
                    this.modalService.alert("MESSAGE_PURCHASEORDER_RECEIVAL_INVALID_LINETOTAL").then(() => {
                        item.unitPrice = backupItem.unitPrice;
                        item.receivableLineTotal = this.getReceivalLineTotal(item);
                    });
                }
            }
        }
        isValidatePoReceival(): boolean {
            if (this.poReceival != null && this.poReceival.receivalLineItems != null) {

                for (var i = 0; i < this.poReceival.receivalLineItems.length; i++) {
                    if (this.poReceival.receivalLineItems[i].variantId == this.backupPoReceival.receivalLineItems[i].variantId
                        && this.poReceival.receivalLineItems[i].productInventoryType == this.backupPoReceival.receivalLineItems[i].productInventoryType
                        && this.poReceival.receivalLineItems[i].orderOfEntry == this.backupPoReceival.receivalLineItems[i].orderOfEntry
                        && this.poReceival.receivalLineItems[i].currentReceiveQuantity > 0 // only checks the line total if receiving items
                        && this.poReceival.receivalLineItems[i].receivableLineTotal < this.backupPoReceival.receivalLineItems[i].receivableLineTotal)
                        return false;
                }
                return true;
            }
        }
        getReceivalLineTotal(item) {
            return this.calculateReceivableLineTotal(item, true);
        }
        getReceivalUnitPrice(item) {
            // item.receiveQuantity + item.currentReceiveQuantity
            var quantity: number = this.roundingService.addNormalizedNumbers(item.receiveQuantity, item.currentReceiveQuantity);
            var numItems: number = quantity;
            if (item.productPackageType == ProductPackageTypeEnum.Case && item.multiplesOf > 0) {
                // total quantity * item.multiplesOf
                numItems = this.roundingService.multiplyNormalizedNumbers(quantity, item.multiplesOf);
            }
            // do not use the normalize functions; we need the decimal places on the unit price
            //return this.roundingService.divideNormalizedNumbers(item.receivableLineTotal, numItems);
            return item.receivableLineTotal / numItems;
        }

        getTotal(type: string): number {
            if (!this.poReceival || !this.poReceival.receivalLineItems) return 0;
            switch (type) {
                case 'overall':
                    // parseFloat(this.poReceival.tax.toString()) + parseFloat(this.poReceival.shippingAndHandling.toString()) + this.getTotal('subtotal')
                    return this.roundingService.addNormalizedNumbersSpread(parseFloat(this.poReceival.tax.toString()), parseFloat(this.poReceival.shippingAndHandling.toString()), this.getTotal('subtotal'));
                case 'subtotal':
                    return this.poReceival.receivalLineItems.reduce((a, b) => this.roundingService.addNormalizedNumbers(a, parseFloat(b.receivableLineTotal.toString())), 0);
                case 'orderquantity':
                    return this.poReceival.receivalLineItems.reduce((a, b) => a + b.orderQuantity, 0);
                case 'receivedquantity':
                    return this.poReceival.receivalLineItems.reduce((a, b) => a + b.currentReceiveQuantity + b.receiveQuantity, 0);
            }
        }

        getItemReceivalUnitPrice(item, unitPrice): number {
            if (!item) return 0
            var price = unitPrice;
            price = unitPrice == 0 ? 0.0 : price;
            // price * (item.multiplesOf ? item.multiplesOf : 1)
            return item.productPackageType == Meevo.Model.ProductPackageTypeEnum.Case ? this.roundingService.multiplyNormalizedNumbers(price, (item.multiplesOf ? item.multiplesOf : 1)) : price;
        }

        Add(item: any): any {
            if (item.orderQuantity <= 99998)
                item.orderQuantity += 1;

            if (item.orderQuantity > 0)
                item.willSave = true;
            else
                item.willSave = false;
        }

        Subtract(item: any): any {
            if (item.orderQuantity >= 1)
                item.orderQuantity -= 1;

            if (item.orderQuantity > 0)
                item.willSave = true;
            else
                item.willSave = false;
        }

        routeToReport(item, barcodes) {
            if (barcodes) {
                return this.reportRouterService.routeToReportWithCustomData(this.meevoSecurityKeys.REPORTS_PRODUCT_DP005, item);
            }

            if (item != null)
                item.isAllPurchaseOrdersChecked = false;

            return this.reportRouterService.routeToReport(this.meevoSecurityKeys.REPORTS_INVENTORY_MI100, item);
        }

        showPrintBarCodesButton(poState) {
            return !this.isEditing();
        }

        /**
         * Before search callbalck
         * @param criteria
         * @param rootCriteria
         */
        preSearchCallback(criteria, rootCriteria) {
            criteria.distributorId = (criteria.distributor && criteria.distributor.id) ? criteria.distributor.id : null;
            criteria.manufacturerId = (criteria.manufacturer && criteria.manufacturer.id) ? criteria.manufacturer.id : null;
        }



        openAuditModal = () => {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/components/auditHistory/auditHistory.html",
                locals: {
                    auditLog: this.auditHistory,
                    userId: this.identityService.current().userId,
                    //auditcreatedrecord: entitycreatedresponse.data,
                    userName: this.identityService.current().userAuthName
                },
                controller: "meevo.auditHistory.AuditHistoryController",
                controllerAs: "auditHistory",
                bindToController: true
            }
            this.modalService.showCustom(options);
        }

        showAuditHistory = () => {
            //if (this.isAdding) return;
            //if (!device.mobile()) this.display.auditDropdown = !this.display.auditDropdown;
            let request = {
                asLocationId: this.identityService.locationId,
                itemsPerPage: 30,
                pageNumber: 0,
                criteria: {
                    entityId: this.purchaseOrder.id,
                    startDate: moment().subtract(2, "years").toDate(),
                    endDate: moment().toDate(),
                    purpose: Meevo.Model.PurposeEnum.Audit,
                    nounId: Meevo.Model.NounEnum.PurchaseOrder,
                }
            }

            return this.dataService.customMethodData("api/ActivityLog/DataChange/List/", "post", request).then((res) => {
                this.auditHistory = res.data;
                //if (!device.mobile()) this.display.auditDropdown = true;
            })
        }

        showViewNotes(purchaseOrderId, purchaseOrderState) {
            this.mode = MaintenanceFormState.Readonly;
            this.viewNotes = true;
            this.pageNoteOrigin(1);
            this.selectPurchaseOrder(purchaseOrderId).then(() => {
                this.getNotes(purchaseOrderId, purchaseOrderState);
            });
        }

        orderUnitPriceChanged(item: PurchaseOrderDetails) {
            this.isDirty = true;

            // updating the unit price removes all other discounts and replaces it with a Specific Price discount
            var discount: Model.PurchaseOrderDiscount = {
                type: Model.PurchaseOrderDiscountTypeEnum.SpecificPrice,
                discountValue: item.unitPrice,
                discountAmount: this.roundingService.subtractNormalizedNumbers(item.wholeSale, item.unitPrice)
            };
            this.recalculateTotalPriceWithLineTotal(item);

            item.discountAmount = this.calculateLineTotalWithValues(item.orderQuantity, discount.discountAmount, item.multiplesOf, item.productPackageType);
            item.discounts = [discount];

            this.calculateTotals();
        }

        orderLineTotalChanged(item) {
            this.isDirty = true;

            item.unitPrice = this.getItemUnitPrice(item);

            // updating the line total removes all other discounts and replaces it with a Specific Price discount
            var discount: Model.PurchaseOrderDiscount = {
                type: Model.PurchaseOrderDiscountTypeEnum.SpecificPrice,
                discountValue: item.unitPrice,
                discountAmount: this.roundingService.subtractNormalizedNumbers(item.wholeSale, item.unitPrice)
            };

            item.discountAmount = this.calculateLineTotalWithValues(item.orderQuantity, discount.discountAmount, item.multiplesOf, item.productPackageType);
            item.discounts = [discount];

            this.calculateTotals();
        }

        receivalUnitPriceChanged(item) {
            this.isDirty = true;
            item.receivableLineTotal = this.getReceivalLineTotal(item);
            this.updatePurchaseOrderLineItemDiscount(item)
        }

        receivalLineTotalChanged(item) {
            this.isDirty = true;
            item.unitPrice = this.getReceivalUnitPrice(item);
            this.updatePurchaseOrderLineItemDiscount(item)
        }

        revertReceivalUnitPriceToWholesale(item) {
            item.unitPrice = item.wholeSale || item.wholesale;
            item.receivableLineTotal = this.getReceivalLineTotal(item);
        }

        updateSort() {
            if (this.isDirty) {
                //let additionalButtons = <Meevo.Components.Modal.IModalAdditionalButton[]>[{
                //    contentKey: 'LABEL_CANCEL',
                //    callback: () => { this.modalService.hideWithResponse(null); }
                //}];
                var userOptions: Meevo.Components.Modal.ILocalOptions = { modalClass: 'modal-alert' /*, additionalButtons: additionalButtons */ };
                return this.modalService.confirm("MESSAGE_SAVE_TO_SEARCH_AFTER_QUANTITY_CHANGE", Components.Modal.ModalTranslationModes.Translate, true, userOptions, true)
                    .then((responseToContinue) => {
                        if (responseToContinue) {
                            this.purchaseOrder.sortOption = this.sortOption;
                            var promise = this.showReceival
                                ? this.savePoReceivals(true)
                                : this.savePurchaseOrder(true);
                            return promise.then(() => {
                                return this.updateSort();
                            });
                        }
                        else if (responseToContinue === false) {
                            this.isDirty = false;
                            this.purchaseOrder.sortOption = this.sortOption;
                            return this.updateSort();
                        }
                        else {
                            this.sortOption = this.backupPurchaseOrder.sortOption;
                        }
                    });
            }

            this.purchaseOrder.sortOption = this.sortOption;
            this.busyService.start();
            this.removePurchaseOrderLineItems();

            var promise: ng.IPromise<any>;
            promise = Model.Guard.isSomething(this.purchaseOrder.id)
                ? this.getLineItems(this.purchaseOrder.id, 0)
                : this.search(true);
            promise.then(() => {
                if (this.showReceival && Model.Guard.isSomething(this.purchaseOrder.id)) {
                    return this.getPoReceivalLineItems(this.purchaseOrder.id);
                }
            }).finally(() => {
                this.busyService.stop();
            });
            return promise;
        }

        readonly ItemsPerPage: number = 1000;
        getLineItems(id, pageNo: number = 0) {
            let request = {
                criteria: {
                    purchaseOrderId: id
                },
                sortBy: this.getSortOption(this.purchaseOrder.sortOption),
                pageNumber: pageNo,
                itemsPerPage: this.ItemsPerPage
            };
            return this.dataService.customMethodData("api/PurchaseOrder/" + id + "/LineItem/List", "POST", request)
                .then((response) => {
                    if (response && response.data && response.data.length > 0) {
                        this.purchaseOrder.lineItems.splice(this.purchaseOrder.lineItems.length, 0, ...response.data);
                        if (response.data.length >= this.ItemsPerPage) {
                            return this.getLineItems(id, pageNo++);
                        }
                    }
                });
        }

        getRequest(pageNum, itemsPerPage) {
            var applyColumnSorting = Model.Guard.isSomething(this.purchaseOrder.sortOption);
            this.productSearchCriteria.purchaseOrderId = this.purchaseOrder.id;

            this.productSearchCriteria.manufacturerIds = this.allManufacturersSelected ? [] : this.manufacturerMoverModel.manufacturerIds;

            if (this.productSearchCriteria.productInventoryType !== Model.ProductInventoryTypeEnum.Other) {
                this.productSearchCriteria.productSubCategoryIds = this.allProductCategoriesSelected ? [] : this.productCategoryMoverModel.productSubCategoryIds;
                this.productSearchCriteria.supplyCategoryIds = [];
            }
            else {
                this.productSearchCriteria.supplyCategoryIds = this.allSupplyCategoriesSelected ? [] : this.supplyCategoryMoverModel.supplyCategoryIds;
                this.productSearchCriteria.productSubCategoryIds = [];
            }

            return {
                pageNumber: pageNum,
                itemsPerPage: itemsPerPage,
                criteria: this.productSearchCriteria,
                sortBy: this.getSortOption((applyColumnSorting ? this.purchaseOrder.sortOption : "OrderOfEntry")),
                sortDirection: Model.SortDirection.Ascending
            };
        }

        private itemsPerPage: number = 200;

        search(force: boolean = false): ng.IPromise<any> {
            if (!force && this.isAdding() && !this.isDistributorSelected) {
                return this.validateDistributorSelection(true);
            }

            if (!force && this.isDistributorChanged && this.productSearchCriteria.distributorId != null) {
                return this.modalService.confirm("MESSAGE_SAVE_TO_SEARCH_AFTER_DISTRIBUTOR_CHANGE")
                    .then((responseToContinue) => {
                        if (responseToContinue) {
                            return this.savePurchaseOrder(true)
                                .then(() => {
                                    return this.search(true);
                                });
                        }
                    });
            }

            if (this.isDirty) {
                var userOptions: Meevo.Components.Modal.ILocalOptions = { modalClass: 'modal-alert' /*, additionalButtons: additionalButtons */ };
                return this.modalService.confirm("MESSAGE_SAVE_TO_SEARCH_AFTER_QUANTITY_CHANGE", Components.Modal.ModalTranslationModes.Translate, true, userOptions, true)
                    .then((responseToContinue) => {
                        if (responseToContinue) {
                            return this.savePurchaseOrder(true)
                                .then(() => {
                                    return this.search(true);
                                });
                        }
                        else {
                            this.isDirty = false;
                            return this.search(true);
                        }
                    });
            }

            this.lockSort = true;
            this.busyService.start();
            this.removePurchaseOrderLineItems();
            return this.performSearch(0)
                .then(() => {
                })
                .finally(() => {
                    this.dateLoadProducts = moment().toDate();
                    this.calculateTotals();
                    this.calculateDiscountTotals();

                    this.busyService.stop();
                    // usage tracking
                    this.dataService.trackUsage(Model.NounEnum.PurchaseOrder, Model.VerbEnum.SearchButtonClicked, this.productSearchCriteria);
                    //this.showResults = true;
                    this.isFirstSearch = false;
                    this.hideReceivalSidebar();
                    if (Model.Guard.isNothing(this.purchaseOrder.id)) {
                        this.purchaseOrder.distributorId = this.productSearchCriteria.distributorId;
                        this.purchaseOrder.manufacturerId = this.productSearchCriteria.manufacturerId;
                        this.purchaseOrder.productInventoryType = this.productSearchCriteria.productInventoryType;
                        this.purchaseOrder.supplyCategoryEnum = this.productSearchCriteria.supplyCategoryEnum;
                        this.purchaseOrder.manufacturerIds = this.productSearchCriteria.manufacturerIds;
                        this.purchaseOrder.productSubCategoryIds = this.productSearchCriteria.productSubCategoryIds;
                        this.purchaseOrder.supplyCategoryIds = this.productSearchCriteria.supplyCategoryIds;
                    }
                });
        }

        performSearch(pageNumber: number = 0): ng.IPromise<any> {
            return this.dataService.customMethodData("api/PurchaseOrder/Product/List/", "POST", this.getRequest(pageNumber, this.itemsPerPage))
                .then((response) => {
                    if (response && response.data && response.data.length > 0) {
                        let dataToPush = response.data.filter(x => x.objectState == Model.ObjectStateEnum.Active || x.orderOfEntry > 0)

                        dataToPush.forEach((item: PurchaseOrderDetails) => {
                            item.onHandDecimalPrecision = this.getOnHandDecimalPrecision(item);
                        });

                        this.purchaseOrder.lineItems.push(...dataToPush);
                        if (response.data.length >= this.itemsPerPage) {
                            return this.performSearch(++pageNumber);
                        }
                    }
                    return this.purchaseOrder.lineItems;
                });
        }

        getOnHandDecimalPrecision(item: Model.PurchaseOrderDetails): any {
            if (!item) {
                return;
            }

            let isPartialAmount = this.tenantEnableProductUsageTracking
                && item.enableProductUsageTracking
                && item.productUsageType == ProductUsageAmountTypeEnum.PartialAmount;
            return (!Number.isInteger(item.onHand) || isPartialAmount) ? this.decimalPrecision : null;
        }

        get canAddDiscounts(): boolean {
            return (this.isAdding() || this.isEditing())
                && this.purchaseOrder
                && this.purchaseOrder.objectState != Model.ObjectStateEnum.Deleted
                && this.purchaseOrder.purchaseOrderState == Model.PurchaseOrderStateEnum.NotReceived;
        }

        removeAllDiscounts() {
            this.purchaseOrder.totalPrice = 0;
            this.purchaseOrder.lineItems.forEach((item) => {
                item.discounts = [];
                item.discountAmount = 0;
                item.unitPrice = item.wholeSale;
                item.lineTotal = this.getLineTotal(item);
                this.purchaseOrder.totalPrice = this.roundingService.addNormalizedNumbers(this.purchaseOrder.totalPrice || 0, item.lineTotal);
            });
            this.purchaseOrder.totalDiscount = 0;
            this.totalDiscountedPriceOfDiscountedItems = 0;
            this.totalUndiscountedPriceOfDiscountedItems = 0;
            this.totalDiscountsForSelectedItems = 0;
            this.totalDiscountedLineTotal = 0;
        }

        selectDiscount(type: Model.PurchaseOrderDiscountTypeEnum) {
            this.discountToApply.type = type;
            this.discountToApply.discountAmount = 0;
            this.discountToApply.discountValue = 0;
            this.discountToApply.isSpread = false;
        }

        isPercentOff() {
            return this.discountToApply.type == Model.PurchaseOrderDiscountTypeEnum.PercentOff;
        }

        isAmountOff() {
            return this.discountToApply.type == Model.PurchaseOrderDiscountTypeEnum.AmountOff;
        }

        isSpecificPrice() {
            return this.discountToApply.type == Model.PurchaseOrderDiscountTypeEnum.SpecificPrice;
        }

        applyDiscount() {
            if (this.discountToApply.discountValue < 0 || (this.discountToApply.discountValue == 0 && this.discountToApply.type != Model.PurchaseOrderDiscountTypeEnum.SpecificPrice)) {
                return;
            }

            var selectedVariants = _.where(this.purchaseOrder.lineItems, { isSelected: true });
            if (selectedVariants.length <= 0) {
                return this.modalService.alert("MESSAGE_NONE_SELECTED");
            }

            switch (this.discountToApply.type) {
                case Model.PurchaseOrderDiscountTypeEnum.PercentOff:
                    this.applyPercentOffDiscount(selectedVariants);
                    break;
                case Model.PurchaseOrderDiscountTypeEnum.AmountOff:
                    this.applyAmountOffDiscount(selectedVariants);
                    break;
                case Model.PurchaseOrderDiscountTypeEnum.SpecificPrice:
                    this.applySpecificPriceDiscount(selectedVariants);
                    break;
                default:
                    break;
            }

            if (this.discountToApply.type != Model.PurchaseOrderDiscountTypeEnum.PercentOff && this.discountToApply.isSpread) {
                // check for missing pennies, calculate based on lineTotals
                this.adjustDiscountIfNeeded(selectedVariants);
            }

            this.calculateTotals();
            this.calculateDiscountTotals();
            this.resetDiscountInput();
        }

        applyPercentOffDiscount(items: PurchaseOrderDetails[]) {
            items.forEach((item: PurchaseOrderDetails, ndx, arr) => {
                item.discounts = item.discounts || [];
                var discount: Model.PurchaseOrderDiscount = {
                    type: Model.PurchaseOrderDiscountTypeEnum.PercentOff,
                    discountValue: this.discountToApply.discountValue,
                    discountAmount: this.roundingService.normalizeDecimalPlaces(item.unitPrice * this.discountToApply.discountValue)
                };
                item.discounts.push(discount);

                let oldUnitPrice = item.unitPrice;
                item.unitPrice = this.roundingService.subtractNormalizedNumbers(item.unitPrice, discount.discountAmount);
                if (item.unitPrice < 0) {
                    discount.discountAmount = this.roundingService.addNormalizedNumbers(discount.discountAmount, item.unitPrice);
                    discount.discountValue = this.roundingService.divideNormalizedNumbers(discount.discountAmount, oldUnitPrice);
                    item.unitPrice = 0;
                }
                this.recalculateTotalPriceWithLineTotal(item);

                item.discountAmount = this.calculateLineDiscount(item);

                item.isSelected = false;
            });
        }

        applyAmountOffDiscount(items: PurchaseOrderDetails[]) {
            let totalUnitPrice: number = 0;
            if (this.discountToApply.isSpread) {
                items.forEach((item) => totalUnitPrice = this.roundingService.addNormalizedNumbers(totalUnitPrice, item.lineTotal));
            }

            items.forEach((item: PurchaseOrderDetails, ndx, arr) => {
                item.discounts = item.discounts || [];
                // NOTE: do not use the normalize functions to calculate the percent value since we want to get more decimal places for accuracy
                let discountAmount = this.discountToApply.isSpread
                    ? this.discountToApply.discountValue * (item.unitPrice / totalUnitPrice)
                    : this.discountToApply.discountValue;
                var discount: Model.PurchaseOrderDiscount = {
                    type: Model.PurchaseOrderDiscountTypeEnum.AmountOff,
                    discountValue: discountAmount,
                    discountAmount: discountAmount,
                    isSpread: this.discountToApply.isSpread
                };
                item.discounts.push(discount);

                item.unitPrice = this.roundingService.subtractNormalizedNumbers(item.unitPrice, discount.discountAmount);
                if (item.unitPrice < 0) {
                    discount.discountAmount = this.roundingService.addNormalizedNumbers(discount.discountAmount, item.unitPrice);
                    discount.discountValue = discount.discountAmount;
                    item.unitPrice = 0;
                }
                this.recalculateTotalPriceWithLineTotal(item);

                item.discountAmount = this.calculateLineDiscount(item);

                item.isSelected = false;
            });
        }

        applySpecificPriceDiscount(items: PurchaseOrderDetails[]) {
            let totalUnitPrice: number = 0, percent: number = 0;

            items.forEach((item) => {
                // specific price discount means we will be removing previous discounts and set price accordingly
                item.lineTotal = this.calculateLineTotalWithValues(item.orderQuantity, item.wholeSale, item.multiplesOf, item.productPackageType);
                if (this.discountToApply.isSpread) {
                    totalUnitPrice = this.roundingService.addNormalizedNumbers(totalUnitPrice, item.lineTotal);
                }
            });

            if (this.discountToApply.isSpread) {
                let diff = this.roundingService.subtractNormalizedNumbers(totalUnitPrice, this.discountToApply.discountValue);
                // NOTE: do not use the normalize functions to calculate the percent value since we want to get more decimal places for accuracy
                percent = diff / totalUnitPrice;
            }

            items.forEach((item: PurchaseOrderDetails, ndx, arr) => {
                item.discounts = []; // remove all discounts when applying a specific price discount
                item.unitPrice = item.wholeSale;
                let discountValue = this.discountToApply.isSpread
                    ? item.unitPrice * percent
                    : this.discountToApply.discountValue;
                var discount: Model.PurchaseOrderDiscount = {
                    type: Model.PurchaseOrderDiscountTypeEnum.SpecificPrice,
                    discountValue: this.discountToApply.isSpread
                        ? this.roundingService.subtractNormalizedNumbers(item.unitPrice, discountValue)
                        : discountValue,
                    discountAmount: this.discountToApply.isSpread
                        ? discountValue
                        : this.roundingService.subtractNormalizedNumbers(item.unitPrice, discountValue),
                    isSpread: this.discountToApply.isSpread
                };
                item.discounts.push(discount);

                item.unitPrice = this.roundingService.subtractNormalizedNumbers(item.unitPrice, discount.discountAmount);

                // NOT going to happen since you cannot enter a negative value as specific price
                if (item.unitPrice < 0) {
                    item.unitPrice = 0;
                }
                this.recalculateTotalPriceWithLineTotal(item);

                item.discountAmount = this.calculateLineDiscount(item);

                item.isSelected = false;
            });
        }

        adjustDiscountIfNeeded(items: PurchaseOrderDetails[]) {
            if (this.discountToApply.type == Model.PurchaseOrderDiscountTypeEnum.PercentOff || !this.discountToApply.isSpread) {
                // percent-off; no pennies to account for
                return;
            }

            let discountTotalApplied: number = 0;
            items.forEach((item: PurchaseOrderDetails, ndx, arr) => {
                if (item.discounts.length > 0) {
                    let totalQuantity: number = item.orderQuantity;
                    if (item.productPackageType == ProductPackageTypeEnum.Case && item.multiplesOf >= 1) {
                        totalQuantity = this.roundingService.multiplyNormalizedNumbers(totalQuantity, item.multiplesOf);
                    }
                    discountTotalApplied = this.roundingService.addNormalizedNumbers(discountTotalApplied, (item.discounts[item.discounts.length - 1].discountValue * totalQuantity));
                }
            });

            if (discountTotalApplied != this.discountToApply.discountValue) {
                let amountToSpread = this.discountToApply.type == Model.PurchaseOrderDiscountTypeEnum.SpecificPrice
                    ? this.roundingService.subtractNormalizedNumbers(discountTotalApplied, this.discountToApply.discountValue)
                    : this.roundingService.subtractNormalizedNumbers(this.discountToApply.discountValue, discountTotalApplied);
                if (amountToSpread == 0) {
                    // nothing to spread
                    return;
                }

                let decrementAmount = this.roundingService.multiplyNormalizedNumbers(this.roundingService.divideNormalizedNumbers(amountToSpread, Math.abs(amountToSpread)), 0.01);
                let ndx = 0;
                while (Math.abs(amountToSpread) > 0) {
                    let item = items[ndx];
                    if (item.lineTotal > 0) {
                        item.lineTotal = this.roundingService.subtractNormalizedNumbers(item.lineTotal, decrementAmount);
                        item.unitPrice = this.getItemUnitPrice(item);
                        item.discountAmount = this.roundingService.addNormalizedNumbers(item.discountAmount, decrementAmount);
                        var totalQuantity: number = item.orderQuantity;
                        if (item.productPackageType == Meevo.Model.ProductPackageTypeEnum.Case && item.multiplesOf > 0) {
                            totalQuantity = this.roundingService.multiplyNormalizedNumbers(totalQuantity, item.multiplesOf);
                        }

                        let lineTotalDiscountAmount = 0;
                        let lineTotalBeforeLastDiscount: number = this.calculateLineTotalWithValues(item.orderQuantity, item.wholeSale, item.multiplesOf, item.productPackageType);
                        if (item.discounts.length > 0) {
                            let lastDiscountIndex = item.discounts.length - 1;
                            let lastDiscountItem = item.discounts[lastDiscountIndex];

                            let perQuantityDecrement = this.roundingService.divideNormalizedNumbers(decrementAmount, totalQuantity);
                            lastDiscountItem.discountValue = lastDiscountItem.isSpread
                                ? this.roundingService.addNormalizedNumbers(lastDiscountItem.discountValue, perQuantityDecrement)
                                : lastDiscountItem.discountValue + perQuantityDecrement;
                            lastDiscountItem.discountAmount = lastDiscountItem.isSpread
                                ? lastDiscountItem.discountAmount + perQuantityDecrement
                                : this.roundingService.addNormalizedNumbers(lastDiscountItem.discountAmount, perQuantityDecrement);
                        }

                        amountToSpread = this.roundingService.subtractNormalizedNumbers(amountToSpread, decrementAmount);
                    }

                    ndx++;
                    if (ndx >= items.length) {
                        // if amount to spread is greater than 0.01 * items.length, there's something wrong
                        break;
                    }
                }
            }
        }

        resetDiscountInput() {
            this.discountToApply.type = Model.PurchaseOrderDiscountTypeEnum.PercentOff;
            this.discountToApply.discountAmount = 0;
            this.discountToApply.discountValue = 0;
            this.discountToApply.isSpread = false;
            this.selectedAll = false;
        }

        getDiscountedItems(): PurchaseOrderDetails[] {
            if (!this.purchaseOrder || !this.purchaseOrder.lineItems) {
                return [];
            }

            return _.filter(this.purchaseOrder.lineItems, (item) => { return item.discounts != null && item.discounts.length > 0; });
        }

        removeDiscount(item: PurchaseOrderDetails, discount: Model.PurchaseOrderDiscount) {
            var ndx: number = _.indexOf(item.discounts, discount, false);
            if (ndx >= 0) {
                if (ndx < item.discounts.length - 1) {
                    var unitPrice = item.wholeSale;
                    item.discountAmount = 0;
                    item.discounts.forEach((discount, i, arr) => {
                        if (ndx != i) {
                            switch (discount.type) {
                                case Model.PurchaseOrderDiscountTypeEnum.PercentOff:
                                    discount.discountAmount = this.roundingService.normalizeDecimalPlaces(unitPrice * discount.discountValue);
                                    break;
                                case Model.PurchaseOrderDiscountTypeEnum.AmountOff:
                                    discount.discountAmount = discount.discountValue;
                                    break;
                                case Model.PurchaseOrderDiscountTypeEnum.SpecificPrice:
                                    discount.discountAmount = this.roundingService.subtractNormalizedNumbers(unitPrice, discount.discountValue);
                                    break;
                                default:
                                    break;
                            }
                            unitPrice = this.roundingService.subtractNormalizedNumbers(unitPrice, discount.discountAmount);
                            item.discountAmount = this.roundingService.addNormalizedNumbers(item.discountAmount, discount.discountAmount);
                        }
                    });
                    item.unitPrice = unitPrice;
                }
                else { // last discount, don't need to recalculate from the start
                    if (ndx == 0) {
                        item.unitPrice = item.wholeSale;
                        item.discountAmount = 0;
                    }
                    else {
                        item.unitPrice = this.roundingService.addNormalizedNumbers(item.unitPrice, discount.discountAmount);
                        item.discountAmount = this.roundingService.subtractNormalizedNumbers(item.discountAmount || 0, discount.discountAmount);
                        item.discountAmount = (item.discountAmount < 0) ? 0 : item.discountAmount;
                    }
                }
                item.discounts.splice(ndx, 1);
                this.recalculateTotalPriceWithLineTotal(item);
                this.purchaseOrder.totalDiscount = this.roundingService.subtractNormalizedNumbers(this.purchaseOrder.totalDiscount || 0, discount.discountAmount);
                this.calculateDiscountTotals();
            }
        }

        selectAllForDiscount() {
            this.purchaseOrder.lineItems.forEach((item) => {
                if (!this.isNotAllowedToEdit(item)) {
                    item.isSelected = this.selectedAll;
                }
            });
        }

        selectedItemForDiscount(item) {
            if (this.selectedAll && !item.isSelected) {
                this.selectedAll = false;
            }
        }

        calculateTotals() {
            try {
                this.purchaseOrder.itemTotal = 0;
                this.purchaseOrder.totalDiscount = 0;
                this.purchaseOrder.totalPrice = 0;
                if (this.purchaseOrder != null && this.purchaseOrder.lineItems != null && this.purchaseOrder.lineItems.length > 0) {
                    for (var i = 0; i < this.purchaseOrder.lineItems.length; i++) {
                        var thisItem = this.purchaseOrder.lineItems[i];

                        // treats items in a case individually
                        //total += thisItem.productPackageType === Meevo.Model.ProductPackageTypeEnum.Case ? thisItem.orderQuantity * thisItem.multiplesOf : thisItem.orderQuantity;

                        // treats a case as one regardless of how many inside
                        this.purchaseOrder.itemTotal = this.roundingService.addNormalizedNumbers(this.purchaseOrder.itemTotal, thisItem.orderQuantity);

                        this.purchaseOrder.totalDiscount = this.roundingService.addNormalizedNumbers(this.purchaseOrder.totalDiscount, thisItem.discountAmount || 0);
                        this.purchaseOrder.totalPrice = this.roundingService.addNormalizedNumbers(this.purchaseOrder.totalPrice || 0, thisItem.lineTotal);
                    }
                }
            }
            catch (e) { console.log(e); }
        }

        recalculateTotalPriceWithLineTotal(item) {
            var newLineTotal = this.getLineTotal(item);
            // var diffLineTotal = this.roundingService.subtractNormalizedNumbers(newLineTotal, item.lineTotal);
            // this.purchaseOrder.totalPrice = this.roundingService.addNormalizedNumbers(this.purchaseOrder.totalPrice || 0, diffLineTotal);
            item.lineTotal = newLineTotal;
        }

        updatePurchaseOrderLineItemDiscount(item: PoReceivalLineItem) {
            var poItem = _.findWhere(this.purchaseOrder.lineItems, { id: item.variantId, productInventoryType: item.productInventoryType, orderOfEntry: item.orderOfEntry });
            if (poItem != null) {
                // subtract old discount amount
                this.purchaseOrder.totalDiscount = this.roundingService.subtractNormalizedNumbers(this.purchaseOrder.totalDiscount || 0, poItem.discountAmount);
                poItem.discounts = []; // remove all discounts when applying a specific price discount
                poItem.unitPrice = poItem.wholeSale;
                var discount: Model.PurchaseOrderDiscount = {
                    type: Model.PurchaseOrderDiscountTypeEnum.SpecificPrice,
                    discountValue: item.unitPrice,
                    discountAmount: this.roundingService.subtractNormalizedNumbers(poItem.unitPrice, item.unitPrice)
                };
                poItem.unitPrice = this.roundingService.subtractNormalizedNumbers(poItem.unitPrice, discount.discountAmount);
                if (poItem.unitPrice < 0) {
                    poItem.unitPrice = 0;
                }
                this.recalculateTotalPriceWithLineTotal(poItem);
                poItem.discountAmount = discount.discountAmount;
                poItem.discounts.push(discount);
                poItem.isSelected = false;
                // add new discount amount
                this.purchaseOrder.totalDiscount = this.roundingService.addNormalizedNumbers(this.purchaseOrder.totalDiscount || 0, discount.discountAmount);
            }
        }

        calculateDiscountTotals(items: PurchaseOrderDetails[] = null) {
            this.totalUndiscountedPriceOfDiscountedItems = 0;
            this.totalDiscountedPriceOfDiscountedItems = 0;
            this.totalDiscountsForSelectedItems = 0;
            this.totalDiscountedLineTotal = 0;

            var itemsToLookInto: PurchaseOrderDetails[] = items;
            if (itemsToLookInto == null) {
                if (this.purchaseOrder != null && this.purchaseOrder.lineItems != null && this.purchaseOrder.lineItems.length > 0) {
                    itemsToLookInto = this.purchaseOrder.lineItems;
                }
            }

            if (itemsToLookInto != null && itemsToLookInto.length > 0) {
                for (var i = 0; i < itemsToLookInto.length; i++) {
                    var item = itemsToLookInto[i];
                    if (item.discountAmount != 0 && item.discounts && item.discounts.length > 0) {
                        this.totalUndiscountedPriceOfDiscountedItems = this.roundingService.addNormalizedNumbers(this.totalUndiscountedPriceOfDiscountedItems, item.wholeSale || 0);
                        this.totalDiscountedPriceOfDiscountedItems = this.roundingService.addNormalizedNumbers(this.totalDiscountedPriceOfDiscountedItems, item.unitPrice);
                        this.totalDiscountsForSelectedItems = this.roundingService.addNormalizedNumbers(this.totalDiscountsForSelectedItems, item.discountAmount);
                        this.totalDiscountedLineTotal = this.roundingService.addNormalizedNumbers(this.totalDiscountedLineTotal, item.lineTotal);
                    }
                }
            }
        }

        calculateLineDiscount(item: PurchaseOrderDetails): number {
            let discountAmount: number = 0;

            item.discounts.forEach((d, i, a) => {
                discountAmount = this.roundingService.addNormalizedNumbers(discountAmount, this.calculateLineTotalWithValues(item.orderQuantity, d.discountAmount, item.multiplesOf, item.productPackageType));
            });

            return discountAmount;
        }

        print() {
            var product = this.purchaseOrder;
            var receivals = this.poReceival;

            const callbackFn = (items) => {

                const itemsArray = [];

                for (var i = 0; i < items.length; i++) {
                    let item = items[i];
                    let newObject = {
                        barCode: item.barCode,
                        generalDisplayName: item.sku + " - " + item.displayName,
                        numberOfLabels: item.numberOfLabels || 0,
                        productDisplayName: item.displayName,
                        product_TId: item.productId,
                        sku: item.sku,
                        variant_TId: item.id,
                        received: item.receiveQuantity,
                        variantDisplayName: item.variantDisplayName
                    };
                    //handle multiple retailShopSupply 
                    var matchedVariantProduct = null;
                    for (var j = 0; j < itemsArray.length; j++) {
                        if (itemsArray[j].variant_TId == item.id) {
                            matchedVariantProduct = itemsArray[j];
                            break;
                        }

                    }
                    if (matchedVariantProduct != null) {
                        matchedVariantProduct.numberOfLabels += newObject.numberOfLabels;
                    } else if (items[i].numberOfLabels > 0) {
                        itemsArray.push(newObject);
                    }
                    //handle multiple retailShopSupply
                }

                var obj = {
                    item: itemsArray,
                    reportContextValues: {
                        ProductListWithLabelCounts_TBL: itemsArray,
                        purchaseOrderNumber: this.purchaseOrder.purchaseOrderNumber
                    }
                };
                //Open DP005 Code to transfer to report
                return this.reportRouterService.routeToReportWithData(this.meevoSecurityKeys.REPORTS_PRODUCT_DP005, obj);
            };

            const modalOptions: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/purchaseOrder/printPoDialog/printPoModal.template.html",
                controller: "meevo.plugins.purchaseOrder.PrintPoModalController",
                controllerAs: "vm",

                bindToController: true,
                locals: {
                    product: product,
                    receivals: receivals,
                    callback: callbackFn
                }
            };

            return this.dataService.customMethodData(`api/PurchaseOrder/${this.purchaseOrder.id}/ReceivalTodayLineItem/List`, "GET", null)
                .then((d) => {
                    if (d.data && d.data.length > 0) {
                        var sortedReceivedLineItems = receivals.receivalLineItems.sort((a, b) => { return a.orderOfEntry - b.orderOfEntry; });
                        var dNdx = 0, rNdx = 0;
                        while (dNdx < d.data.length) {
                            var dli: PoReceivalLineItem = d.data[dNdx++];
                            var rli: PoReceivalLineItem = null;
                            while (rNdx < sortedReceivedLineItems.length) {
                                rli = sortedReceivedLineItems[rNdx++];
                                if (dli.variantId == rli.variantId && dli.productInventoryType == rli.productInventoryType && dli.orderOfEntry == rli.orderOfEntry) {
                                    break;
                                }
                            }
                            if (rli) {
                                rli["receivedToday"] = dli.receiveQuantity;
                            }
                        }
                    }

                    return this.modalService.showCustom(modalOptions);
                });
        }

        getMdItemSize(forReceivalScreen: boolean = false): number {
            let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
            let isMobile = vw <= 600;
            let isTablet = vw > 600 && vw < 960;
            if (forReceivalScreen) {
                return isMobile ? this.MdItemSizeMobileReceival : (isTablet ? this.MdItemSizeTabletReceival : this.MdItemSizeDesktopReceival);
            }
            return (isMobile || isTablet) ? this.MdItemSizeMobile : this.MdItemSizeDesktop;
        }

        removeMobilePoLineItem(item: any): void {
            if (item) {
                this.modalService.yellowConfirm('MESSAGE_PURCHASEORDER_RECEIVAL_REMOVEITEM', 0, true, null, false).then((confirmResult: boolean) => {
                    if (confirmResult) {
                        this.removeProductFromCount(item);
                    }
                });
            }
        }

        removePoReceivalLineItem(item: any): void {
            if (item) {
                this.modalService.yellowConfirm('MESSAGE_PURCHASEORDER_RECEIVAL_REMOVEITEM', 0, true, undefined, false).then((confirmResult: boolean) => {
                    if (confirmResult) {
                        if (this.poReceival && this.poReceival.receivalLineItems) {
                            for (var i = 0; i < this.poReceival.receivalLineItems.length; i++) {
                                if (this.poReceival.receivalLineItems[i].variantId == item.variantId
                                    && this.poReceival.receivalLineItems[i].orderOfEntry == item.orderOfEntry
                                    && this.poReceival.receivalLineItems[i].productInventoryType == item.productInventoryType) {

                                    this.poReceival.receivalLineItems.splice(i, 1);
                                    this.removeProductFromCount(item);
                                    break;
                                }
                            }
                        }
                    }
                });
            }
        }

        setSortOption(productInventoryType: Meevo.Model.ProductInventoryTypeEnum): void {
            if (this.purchaseOrder && this.orderItemsByList && productInventoryType) {
                var sortByProductCategoryOption: any = _.findWhere(this.orderItemsByList, { key: "ProductCategory" });
                var sortBySupplyCategoryOption: any = _.findWhere(this.orderItemsByList, { key: "SupplyCategory" });

                if (productInventoryType == Meevo.Model.ProductInventoryTypeEnum.Other) {
                    sortBySupplyCategoryOption.isVisible = true;
                    sortByProductCategoryOption.isVisible = false;
                }
                else {
                    sortBySupplyCategoryOption.isVisible = false;
                    sortByProductCategoryOption.isVisible = true;
                }
            }
        }

        validateDistributorSelection(loadProducts: boolean = false): any {
            if (this.isAdding() && !this.isDistributorSelected) {
                return this.modalService.confirm("MESSAGE_LOAD_PRODUCTS_FROM_ALL_DISTRIBUTORS")
                    .then((responseToContinue) => {
                        if (responseToContinue) {
                            this.productSearchCriteria.newDistributorId = null;
                            this.updateDistributor();
                            if (loadProducts) {
                                return this.search(true);
                            }
                        }
                    });
            }
            else {
                return this.$q.resolve();
            }
        }

        isNotAllowedToAddMoreItems() {
            return this.purchaseOrder != null && this.purchaseOrder.id != null && this.purchaseOrder.purchaseOrderState == PurchaseOrderStateEnum.ReceivedInFull;
        }

        isNotAllowedToEdit(item) {
            return item != null
                && this.purchaseOrder != null
                && ((!item.isNew && this.purchaseOrder.purchaseOrderState == PurchaseOrderStateEnum.PartiallyReceived) || this.purchaseOrder.purchaseOrderState == PurchaseOrderStateEnum.ReceivedInFull || this.purchaseOrder.objectState == Meevo.Model.ObjectStateEnum.Deleted);
        }

        getPurchaseOrderReceivalButtonColor(item): string {
            if (!item) return;
            return item.purchaseOrderState == PurchaseOrderStateEnum.NotReceived ?
                'button-green' : item.purchaseOrderState == PurchaseOrderStateEnum.PartiallyReceived ?
                    'button-yellow' : 'button-outlined'
        }

        getMobileVirtualRepeatHeight(forReceival: boolean = false, isMobile: boolean = false): string {
            let distance = ($(`#purchase-order${forReceival ? '-receival' : ''}-detail-wrapper${isMobile ? '-mobile' : ''}`).offset().top - $(window).scrollTop());
            let vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
            let footerWrapper = $('#purchase-order-footer-wrapper' + (forReceival ? '.receival-header' : '.po-status-bar'))[0];
            let footerHeight = footerWrapper ? footerWrapper.clientHeight : 0;
            let actionButtons = $(`#${forReceival ? 'purchase-order-receival-buttons' : 'purchase-order-crud'}`)[0];
            footerHeight += actionButtons ? actionButtons.clientHeight : 0;
            return `${vh - (distance + footerHeight)}px`
        }

        fixScrolling(): void {
            var timer = setInterval(() => {
                var scroller = document.querySelector('#purchase-order-detail-wrapper .md-virtual-repeat-scroller');
                if (scroller) {
                    scroller.addEventListener('scroll', (e: any) => {
                        this.$scope.$apply();
                    });
                    clearInterval(timer);
                }
            }, 1000);
            var receivalTimer = setInterval(() => {
                var scroller = document.querySelector('#purchase-order-receival-detail-wrapper .md-virtual-repeat-scroller');
                if (scroller) {
                    scroller.addEventListener('scroll', (e: any) => {
                        this.$scope.$apply();
                    });
                    clearInterval(receivalTimer);
                }
            }, 1000);
        }

        showDataToolTip(prefix, item): boolean {
            if (!item) return false;
            let id = `#po-${prefix}-${item.id || item.variantId}${item.productInventoryType}`;
            var el = $(id)[0];
            if (!el) return false;
            return el.scrollHeight > el.clientHeight + 2;
        }

        requiresOrdering(item: Model.PurchaseOrderDetails) {
            return item.modelQuantity > item.orderPoint ? (item.onHand <= item.orderPoint) : (item.onHand < item.orderPoint);
        }

        getLocationDetail() {
            this.dataService.customMethodData(`api/location/maintenance/${this.identityService.locationId}`, 'POST', null)
                .then((res) => {
                    this.isLocationActive = res.data["locationStatus"] == Meevo.Model.LocationStatusEnum.Active;
                });
        }

        isSalonInteractiveAccountActive() {
            if (this.securityChecker.checkCachedSecurityKey(this.securityKeys.INTEGRATION_SALONINTERACTIVE_TAB_ACCOUNT + Meevo.Components.Common.SecurityParts.KEY_PART_READ) == 2056
                || this.securityChecker.checkCachedSecurityKey(this.securityKeys.INVENTORY_PURCHASEORDER_SUBMITPO_ACTION) == 2056) {
                this.dataService.customMethodData("api/SalonInteractiveOrder/", "GET", null).then((d) => {
                    this.isSalonInteractiveAccountObjectStateActive = (d.data["objectState"] == 2026 && d.data["hasValidToken"] === true);
                });
            }
        }

        setupShowExternalOrderingAction(): void {
            this.showExternalOrderingAction = this.purchaseOrder.isAvedaOrderingEnabled
                || _.all(this.purchaseOrder.lineItems, (item) => item.isAvedaOrderingEnabled);

            this.showExternalOrderingActionSalonInteractive = this.isSalonInteractiveAccountObjectStateActive
                && this.isLocationActive
                && this.purchaseOrder.distributorId != null
                && this.purchaseOrder.salonInteractiveDistributorId != null;
        }

    }
}
